<template>
  <div class="app-status-stack">
    <PwaStatusBanner />
    <LocalContinuityBanner v-if="offlineModeEnabled" />
    <LocalModeBanner v-if="offlineModeEnabled" />
  </div>
  <VirtualPrintActionManager :key="partner_token || 'no-partner'" :enabled="virtualPrintManagerEnabled" />
  <SecondaryDeviceBlockedOverlay v-if="showSecondaryDeviceBlockedOverlay" />
  <StaffPinPrompt />
  <!--FIN NAVBAR PARTNER-->
  <!--PAGE DEL PARTNER-->
  <router-view :key="`${operationalViewKey}:${$route.fullPath}`" class="pagePartner" v-if="$route.meta.partnerMenu" :ewu_profesional="ewu_profesional" @ReviseSession="ReviseSession"/>
  <!--PAGE DEL USER Y CAMARERO-->
  <div v-else-if="!$route.meta.fullpage" class="app-page-shell" :class="{ 'app-page-shell--customer': $route.meta.authorized }">
    <header v-if="customerSectionTitle" class="customer-section-header" :class="{ 'customer-section-header--with-logo': restaurant_logo }">
      <div class="customer-section-header__brand" :class="{ 'customer-section-header__brand--compact': restaurant_logo && restaurantLogoIsCompact, 'customer-section-header__brand--text': !restaurant_logo }">
        <img v-if="restaurant_logo" :src="restaurant_logo" :alt="restaurant_name ? 'Logo de ' + restaurant_name : 'Logo del restaurante'" @load="onCustomerHeaderLogoLoad" />
        <span v-else>{{ restaurant_name }}</span>
      </div>
      <div class="customer-section-header__powered">
        <span>Powered by</span>
        <img src="../src/assets/EWU_Negro.png" alt="Eat With Us" />
      </div>
      <h1 class="customer-section-header__title">{{ customerSectionTitle }}</h1>
    </header>
    <router-view :key="`${operationalViewKey}:${$route.fullPath}`" class="page" id="pagina" :max_plates="max_plates" :is_delivery="is_delivery" :loyalty_active="loyalty_active" :rewards="rewards" :open_kitchen="open_kitchen" :accepts_payments="accepts_payments" :payment_method="payment_method" :bizum_enabled="bizum_enabled" :tips_enabled="tips_enabled" :pay_at_order="pay_at_order" :pay_at_order_cash_enabled="pay_at_order_cash_enabled" :payment_config_loaded="payment_config_loaded" :allow_facturation_bdp="allow_facturation_bdp" :is_take_away="is_take_away" :is_counter="is_counter" :loyalty_logged_in="isUserCardLoggedIn" :loyalty_skipped="hasSkipped" :loyalty_points="userPoints" :restaurant_logo="restaurant_logo" @open-loyalty="openRewardsDrawer" @open-loyalty-preferences="openLoyaltyPreferences" @join-loyalty="showUserDataModal = true" @ReviseSession="ReviseSession"/>
    <!--MENU DEL USER-->
    <footer v-if="$route.meta.showFooter" class="app-bottom-nav app-bottom-nav--customer" :class="{ 'app-bottom-nav--solid': (is_delivery || is_take_away) }">
      <div class="row m-0 app-bottom-nav__row">
        <router-link to="/Home" class="col-3 text-decoration-none">
            <i class="fa-solid fa-utensils fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav">Carta</p>
        </router-link>
        <router-link to="/Carrito" class="col-3 text-decoration-none pe-4 carrito" data-tour-id="customer-cart" aria-label="Carrito">
            <span class="amount-carrito px-2">{{carrito}}</span>
            <i class="fa-solid fa-basket-shopping fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav">
              Carrito
            </p>
        </router-link>
        <router-link to="/MisPedidos" class="col-3 text-decoration-none footer-customer-orders" data-tour-id="customer-orders" aria-label="Mis pedidos">
            <i class="fas fa-rectangle-list fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav footer-customer-orders__label">Mis pedidos</p>
        </router-link>
        <router-link to="/Cuenta" class="col-3 text-decoration-none">
            <i class="fas fa-receipt fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav">Cuenta</p>
        </router-link>
      </div>
    </footer>
    <div class="phone-icon d-flex align-items-center shadow" v-if="$route.meta.showFooter && !is_delivery && !is_take_away" @click="OpenCallWaiter()">
      <i class="fas fa-phone fs-2 w-100 text-center text-nav" style="transform: rotate(-270deg)"></i>
    </div>
    <svg class="footer-rounded" viewBox="0 0 100 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-if="$route.meta.showFooter && !is_delivery && !is_take_away">
        <path d="M0 0H42Q50 9 59 -1H100V100H0Z" fill="white" />
    </svg>
    <div class="powered powered--home" v-if="$route.meta.showFooter && $route.name === 'Home'">
      <span class="me-2">Powered by</span>
      <img class="powered__logo" src="../src/assets/EWU_Negro.png" alt="Eat With Us" />
    </div>
    <!--FIN MENU DEL USER-->
    <!--INICIO MENU DEL CAMARERO-->
    <footer v-if="$route.meta.showFooterWaiter" class="app-bottom-nav app-bottom-nav--waiter bg-white shadow">
      <div class="row m-0 pt-3">
        <router-link to="/PanelComandas" class="col-4 text-decoration-none">
            <i class="fa-solid fa-list fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center text-nav">Comandas</p>
        </router-link>
        <router-link to="/PanelMesas" class="col-4 text-decoration-none carrito" >
            <i class="fa-solid fa-chair fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav">Mesas</p>
        </router-link>
        <router-link to="/PuntoDeVenta" class="col-4 text-decoration-none carrito" >
            <i class="fa-solid fa-pen-to-square fs-3 w-100 text-center text-nav"></i>
            <p class="button-text text-center mb-0 text-nav">Apuntar</p>
        </router-link>
      </div>
    </footer>
  </div>
  <router-view :key="`${operationalViewKey}:${$route.fullPath}`" class="page--fullpage" :max_plates="max_plates" :is_delivery="is_delivery" :loyalty_active="loyalty_active" :rewards="rewards" :open_kitchen="open_kitchen" :accepts_payments="accepts_payments" :payment_method="payment_method" :bizum_enabled="bizum_enabled" :tips_enabled="tips_enabled" :pay_at_order="pay_at_order" :pay_at_order_cash_enabled="pay_at_order_cash_enabled" :payment_config_loaded="payment_config_loaded" :allow_facturation_bdp="allow_facturation_bdp" :is_take_away="is_take_away" :is_counter="is_counter" @ReviseSession="ReviseSession" v-else/>
  <LlamadaCamarero></LlamadaCamarero>
  <TpvFloatingControls
    :show-dock="showTpvDock"
    :show-translate="showTranslateButton"
    :dock-items="partnerDockItems"
    :lift-for-footer="shouldLiftTranslateButton"
    :translate-error="translateError"
    @translate="translate"
  />

  <!-- User Data Collection Modal (Loyalty) -->
  <div v-if="loyalty_active && showUserDataModal && ($route.meta.showFooter || $route.meta.authorized)" tabindex="-1" class="user-data-modal-overlay" @click.self="closeUserDataModal">
    <div class="user-data-modal fade-in-up">
      <div class="modal-header-simple">
        <button type="button" class="btn-close-simple" @click="closeUserDataModal">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      <div class="text-center mb-4">
        <div class="icon-circle mb-3">
           <i class="fa-solid fa-gift fs-2" style="color: var(--primary-color)"></i>
        </div>
        <h4 class="fw-bold mb-2">{{ registrationStep === 1 ? '¡Verifica tus puntos!' : registrationStep === 2 ? '¡Únete a nosotros!' : 'Verifica tu correo' }}</h4>
        <p class="text-muted small px-3">
          {{ registrationStep === 1 ? 'Introduce tu correo para ver tus puntos disponibles y acumular más.' : registrationStep === 2 ? 'No hemos encontrado tu perfil. Completa tus datos para registrarte.' : 'Hemos enviado un código de 6 dígitos a ' + userData.email + '. Caduca en 10 minutos.' }}
        </p>
      </div>

      <form @submit.prevent="saveUserData">
        <!-- Step 1: Email only -->
        <div v-if="registrationStep === 1" class="form-floating mb-4">
          <input type="email" class="form-control rounded-4" id="floatingInput" placeholder="name@example.com" v-model.trim="userData.email" required>
          <label for="floatingInput">Correo electrónico</label>
        </div>

        <!-- Step 2: Name and Phone -->
        <div v-if="registrationStep === 2" class="fade-in">
           <div class="form-floating mb-3">
            <input type="text" class="form-control rounded-4" id="floatingName" placeholder="Juan Pérez" v-model="userData.name" required>
            <label for="floatingName">Nombre</label>
          </div>
          <div v-if="registrationStep === 2" class="form-floating mb-4">
            <input type="tel" class="form-control rounded-4" id="floatingPhone" placeholder="Teléfono" v-model="userData.phone">
            <label for="floatingPhone">Teléfono (Opcional)</label>
          </div>
          <LoyaltyBirthdayField v-if="registrationLegal?.ask_birth_date" id="loyalty-registration-birthday" v-model="registrationPreferences" :disabled="loading" />
        </div>

        <div v-if="registrationStep === 3" class="mb-3">
          <label for="loyalty-registration-code" class="form-label fw-semibold">Código de verificación</label>
          <input id="loyalty-registration-code" ref="loyaltyRegistrationCodeInput" v-model.trim="registrationCode"
            type="text" name="one-time-code" inputmode="numeric" autocomplete="one-time-code"
            maxlength="6" pattern="[0-9]{6}" class="form-control rounded-4" placeholder="000000" required>
          <div class="d-flex justify-content-between mt-2">
            <button type="button" class="btn btn-link btn-sm" :disabled="loading" @click="editLoyaltyRegistrationEmail">Cambiar correo</button>
            <button type="button" class="btn btn-link btn-sm" :disabled="loading" @click="requestRegistrationCode">Reenviar código</button>
          </div>
        </div>
        <LoyaltyPreferenceChoices v-if="registrationStep === 2" v-model="registrationPreferences" :legal="registrationLegal" :registration="true" :show-wallet="!!walletPlatform" :wallet-name="walletDisplayName" :disabled="loading" />
        <p v-if="registrationStep === 2 && !registrationLegal" class="text-muted small" role="status">Cargando información de privacidad…</p>
        <p v-if="registrationError" class="text-danger small" role="alert">{{ registrationError }}</p>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-outline-secondary w-50 rounded-pill py-3 fw-bold shadow-sm" @click="closeUserDataModal">
            Cancelar
          </button>
          <button type="submit" class="btn text-white w-50 rounded-pill py-3 fw-bold shadow-sm" style="background-color: var(--primary-color); border-color: var(--primary-color)" :disabled="!isFormValid || loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ registrationStep === 1 ? 'Verificar' : registrationStep === 2 ? 'Enviar código' : 'Confirmar registro' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <LoyaltyLoginSuccess
    v-if="showLoyaltySuccess"
    :points="userPoints"
    :email="userData.email"
    :restaurant-name="restaurant_name"
    :is-new="loyaltySuccessKind === 'registered'"
    :review-preferences="preferencesReviewRequired"
    @review-preferences="openLoyaltyPreferences"
    :show-wallet="!!walletPlatform"
    :wallet-platform="walletPlatform"
    @close="showLoyaltySuccess = false"
    @view-rewards="viewRewardsFromSuccess"
    @add-wallet="addWalletFromSuccess"
  />

  <!-- Floating Points Badge (Loyalty) -->
  <div v-if="loyalty_active && (isUserCardLoggedIn || hasSkipped) && $route.meta.showFooter && $route.name !== 'Home'" class="floating-points slide-in-bottom">
    <button v-if="isUserCardLoggedIn" type="button" class="points-badge" :aria-label="`Ver recompensas: ${userPoints} puntos`" @click="openRewardsDrawer">
      <i class="fa-solid fa-gift" aria-hidden="true"></i>
      <span>{{ userPoints }} pts</span>
    </button>
    <button v-else type="button" class="points-badge invite-badge" aria-label="Unirme a la fidelización" @click="showUserDataModal = true">
      <i class="fa-solid fa-gift" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Rewards Drawer (Loyalty) -->
  <div v-if="showRewardsDrawer" class="drawer-overlay" @click="showRewardsDrawer = false">
    <div class="rewards-drawer" @click.stop>
      <div class="drawer-header">
        <div class="drawer-heading">
          <span class="drawer-kicker"><i class="fa-solid fa-sparkles"></i> TU FIDELIDAD</span>
          <h5>Tus recompensas</h5>
          <p>Sigue acumulando y desbloquea premios</p>
        </div>
        <div class="drawer-balance">
          <span>Tu saldo</span>
          <strong>{{ userPoints }} <small>pts</small></strong>
        </div>
        <button class="btn-close-drawer" aria-label="Cerrar recompensas" @click="showRewardsDrawer = false">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      <div class="drawer-body">
        <div v-if="rewards.length === 0" class="text-center text-muted py-5">
          <i class="fa-solid fa-gift fs-1 mb-3 d-block"></i>
          <p>No hay recompensas disponibles</p>
        </div>
        <div v-else class="rewards-list">
          <div v-for="(reward, index) in orderedRewards" :key="index" 
              class="reward-card"
              :class="{ 'disabled': !canRedeemRewardFromList(reward), 'reward-card--ready': canRedeemRewardFromList(reward) }">
            <div class="reward-card__top">
              <div class="reward-kind">
                <span class="reward-kind__icon" :class="rewardKindClass(reward)">
                  <i class="fa-solid" :class="rewardKindIcon(reward)"></i>
                </span>
                <span>{{ rewardKindLabel(reward) }}</span>
              </div>
              <span v-if="reward.type !== 'buy_x_get_y'" class="reward-cost">{{ reward.necessary_points }} pts</span>
              <span v-else class="reward-cost reward-cost--purchase">Compra {{ reward.buy_quantity }}</span>
            </div>
            <h3 class="reward-title">{{ reward.name }}</h3>
            <p class="reward-description">
              <template v-if="reward.type === 'buy_x_get_y'">
                Compra {{ reward.buy_quantity }} × {{ reward.qualifying_label || 'producto/categoría' }}
                <span class="reward-description__gift">y llévate gratis {{ rewardTargetLabel(reward) }}</span>
              </template>
              <template v-else-if="reward.type === 'discount'">
                {{ reward.discount }}% de descuento en tu pedido
              </template>
              <template v-else>
                Un producto gratis al alcanzar los puntos necesarios.
              </template>
            </p>
            <div class="reward-progress">
              <div class="reward-progress__meta">
                <span>Tu progreso</span>
                <strong>{{ rewardProgressCurrent(reward) }} / {{ rewardProgressTarget(reward) }} {{ rewardProgressUnit(reward) }}</strong>
              </div>
              <div class="reward-progress__track" role="progressbar" :aria-valuenow="rewardProgressPercent(reward)" aria-valuemin="0" aria-valuemax="100">
                <div class="reward-progress__fill" :style="{ width: rewardProgressPercent(reward) + '%' }"></div>
              </div>
              <div class="reward-progress__status" :class="{ 'is-ready': canRedeemRewardFromList(reward) }">
                <i class="fa-solid" :class="canRedeemRewardFromList(reward) ? 'fa-circle-check' : 'fa-arrow-trend-up'"></i>
                {{ rewardProgressStatusText(reward) }}
              </div>
            </div>
            <div class="reward-card__footer">
              <span v-if="canRedeemRewardFromList(reward)" class="reward-unlocked">
                <i class="fa-solid fa-unlock-keyhole"></i> {{ rewardUnlockedText(reward) }}
              </span>
              <span v-else class="reward-locked-note">
                <i class="fa-solid fa-lock"></i> Aún bloqueada
              </span>
              <button v-if="canRedeemRewardFromList(reward)" class="reward-action" @click="redeemReward(reward)">
                Canjear <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        <LoyaltyCommunicationSettings v-if="isUserCardLoggedIn" ref="communicationSettings" :token="token" />
      </div>
      <div class="drawer-footer">
        <div v-if="walletPlatform && isUserCardLoggedIn" class="wallet-issuance">
          <template v-if="walletStage === 'idle'">
            <GoogleWalletButton v-if="walletPlatform === 'google'" :disabled="walletBusy" :busy="walletBusy" @click="requestWalletCode" />
            <button v-else type="button" class="wallet-add-button" :disabled="walletBusy" @click="requestWalletCode">
              <span v-if="walletBusy" class="spinner-border spinner-border-sm me-2"></span>
              Añadir a Apple Wallet
            </button>
          </template>
          <div v-else class="wallet-code-form">
            <label for="wallet-code">Introduce el código enviado a {{ userData.email }}</label>
            <div class="wallet-code-row">
              <input id="wallet-code" ref="walletCodeInput" name="one-time-code" v-model.trim="walletCode" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="Código de 6 dígitos">
              <button type="button" :disabled="walletBusy || !/^\d{6}$/.test(walletCode)" @click="completeWallet">
                <span v-if="walletBusy" class="spinner-border spinner-border-sm"></span>
                <span v-else>Continuar</span>
              </button>
            </div>
            <button type="button" class="wallet-resend" :disabled="walletBusy" @click="requestWalletCode">Reenviar código</button>
          </div>
          <p v-if="walletError" class="wallet-error" role="alert">{{ walletError }}</p>
        </div>
        <button class="btn-logout-loyalty" @click="logoutLoyalty">
          <i class="fa-solid fa-right-from-bracket me-2"></i>Cerrar sesión
        </button>
      </div>
    </div>
  </div>

  <!-- Reward Preview & Redemption Modal -->
  <div v-if="showRewardPreviewModal" class="user-data-modal-overlay" @click.self="showRewardPreviewModal = false">
    <div class="user-data-modal fade-in-up">
      <div class="modal-header-simple">
        <button type="button" class="btn-close-simple" @click="showRewardPreviewModal = false">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      
      <!-- SUCCESS STATE -->
      <div v-if="isRedeemedSuccess">
        <div class="text-center mb-4">
          <div class="icon-circle mb-3" style="background-color: #e8f5e9;">
             <i class="fa-solid fa-circle-check fs-2" style="color: #4caf50"></i>
          </div>
          <h4 class="fw-bold mb-2">¡Canjeado con éxito!</h4>
          <p class="text-muted small px-3">Enseña este ticket al personal para disfrutar de tu recompensa.</p>
        </div>

        <div v-if="rewardPreviewDetails" class="redeemed-reward-ticket mb-4">
          <div class="ticket-content text-center p-3">
            <h5 class="fw-bold mb-1">{{ rewardPreviewDetails.name }}</h5>
            <div class="badge rounded-pill bg-success mb-3" v-if="rewardPreviewDetails.type === 'product' || rewardPreviewDetails.type === 'buy_x_get_y'">PRODUCTO GRATIS</div>
            <div class="badge rounded-pill bg-warning text-dark mb-3" v-else>{{ rewardPreviewDetails.discount }}% DE DESCUENTO</div>
            
            <!-- Resulting Plate -->
            <div v-if="rewardPreviewDetails.plate" class="plate-details mt-2">
              <div v-if="rewardPreviewDetails.plate.photo" class="d-flex justify-content-center mb-2">
                <img :src="rewardPreviewDetails.plate.photo" class="rounded-3 shadow-sm" style="width: 80px; height: 80px; object-fit: cover;">
              </div>
              <div v-else class="d-flex justify-content-center mb-2">
                <div class="rounded-3 shadow-sm d-flex align-items-center justify-content-center bg-white border" style="width: 80px; height: 80px;" v-html="noPhoto"></div>
              </div>
              <p class="mb-0 fw-semibold">{{ rewardPreviewDetails.plate.name }}</p>
            </div>
          </div>
          <div class="ticket-dashed-line"></div>
          <div class="ticket-footer p-3 text-center">
            <small class="text-muted d-block mb-1">ID de canje:</small>
            <code class="text-dark">{{ rewardPreviewDetails.id.substring(0, 8).toUpperCase() }}</code>
          </div>
        </div>

        <button class="btn text-white w-100 rounded-pill py-3 fw-bold shadow-sm" 
                style="background-color: var(--primary-color)" 
                @click="showRewardPreviewModal = false">
          Entendido
        </button>
      </div>

      <!-- FINAL CONFIRMATION STATE -->
      <div v-else-if="showFinalConfirmation">
        <div class="text-center mb-4">
          <div class="icon-circle mb-3" style="background-color: #fff3e0; width: 60px; height: 60px; border-radius: 50%; margin: 0 auto; display: flex; align-items: center; justify-content: center;">
             <i class="fa-solid fa-triangle-exclamation fs-3" style="color: #ff9800"></i>
          </div>
          <h4 class="fw-bold mb-2">¿Confirmar?</h4>
          <div class="p-3 rounded-4 mb-3" style="background-color: #f8f9fa;">
            <p v-if="rewardPreviewDetails.type === 'buy_x_get_y'" class="text-muted small mb-0">
              Has completado la promoción de <span class="fw-bold text-dark">{{ rewardPreviewDetails.buy_quantity }} × {{ rewardPreviewDetails.qualifying_label || 'producto' }}</span>.
            </p>
            <p v-else class="text-muted small mb-0">
              Vas a gastar <span class="fw-bold text-dark">{{ rewardPreviewDetails.necessary_points }} puntos</span> de tu cuenta.
            </p>
            <p v-if="rewardPreviewDetails.type === 'product' || rewardPreviewDetails.type === 'buy_x_get_y'" class="text-muted small mt-2 mb-0">
              Se realizará un pedido gratuito de <span class="fw-bold text-dark">{{ selectedRewardPlateName }}</span> de forma inmediata.
            </p>
            <p v-else class="text-muted small mt-2 mb-0">
              Se aplicará el descuento a tu pedido actual de forma inmediata.
            </p>
          </div>
          <p class="text-danger fw-bold small">Esta acción no se puede deshacer.</p>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary w-50 rounded-pill py-3 fw-bold shadow-sm" @click="showFinalConfirmation = false" :disabled="loading">
            Atrás
          </button>
          <button class="btn text-white w-50 rounded-pill py-3 fw-bold shadow-sm" 
                  style="background-color: var(--primary-color); border-color: var(--primary-color)"
                  @click="handleRedemptionClick"
                  :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            <span v-else-if="requiresPayment">Pedir y Pagar</span>
            <span v-else>Sí, finalizar</span>
          </button>
        </div>
      </div>

      <!-- PREVIEW / SELECTION STATE -->
      <div v-else-if="rewardPreviewDetails">
        <div class="text-center mb-4">
          <h4 class="fw-bold mb-2">Canjear Recompensa</h4>
          <p class="text-muted small px-3">Revisa los detalles antes de confirmar el canje de puntos.</p>
        </div>

        <div class="reward-preview-card p-3 mb-4 rounded-4 bg-light border text-center">
          <h5 class="fw-bold mb-1">{{ rewardPreviewDetails.name }}</h5>
          <p v-if="rewardPreviewDetails.type === 'buy_x_get_y'" class="text-muted mb-3">
            Compra {{ rewardPreviewDetails.buy_quantity }} × {{ rewardPreviewDetails.qualifying_label || 'producto' }} · Elige tu regalo gratis
          </p>
          <p v-else class="text-muted mb-3">{{ rewardPreviewDetails.necessary_points }} puntos necesarios</p>
          
          <!-- Case: Single Plate -->
          <div v-if="rewardPreviewDetails.plate" class="mb-4">
             <div v-if="rewardPreviewDetails.plate.photo" class="d-flex justify-content-center mb-2">
                <img :src="rewardPreviewDetails.plate.photo" class="rounded-3 shadow-sm" style="width: 100px; height: 100px; object-fit: cover;">
             </div>
             <div v-else class="d-flex justify-content-center mb-2">
                <div class="rounded-3 shadow-sm d-flex align-items-center justify-content-center bg-white border" style="width: 100px; height: 100px;" v-html="noPhoto"></div>
             </div>
             <p class="mb-0 fw-semibold">{{ rewardPreviewDetails.plate.name }}</p>
          </div>

          <!-- Case: Multiple Plates Selection -->
          <div v-if="rewardPreviewDetails.plates && rewardPreviewDetails.plates.length > 0" class="mb-3 text-start">
             <p class="fw-bold small mb-2 text-center">Selecciona un producto:</p>
             <div class="plate-selection-list">
                <div v-for="plate in rewardPreviewDetails.plates" :key="plate.id" 
                     class="plate-selection-item d-flex align-items-center p-2 mb-2 rounded-3 border bg-white"
                     :class="{'selected': selectedRewardPlateId === plate.id}"
                     @click="selectedRewardPlateId = plate.id">
                   <div v-if="plate.photo" class="me-3">
                      <img :src="plate.photo" class="rounded-2" style="width: 50px; height: 50px; object-fit: cover;">
                   </div>
                   <div v-else class="me-3">
                      <div class="rounded-2 d-flex align-items-center justify-content-center bg-light border" style="width: 50px; height: 50px;" v-html="noPhoto"></div>
                   </div>
                      <span class="flex-grow-1 fw-medium small">{{ plate.name }}<br>
                        <span class="text-muted text-decoration-line-through me-2 fs-6">{{ plate.price }}€</span>
                        <span class="fw-bold fs-5" style="color: #4caf50;">0€</span>
                      </span>
                      <i class="fa-solid" :class="selectedRewardPlateId === plate.id ? 'fa-circle-check text-success' : 'fa-circle text-muted opacity-25'"></i>
                </div>
             </div>
          </div>

          <!-- Case: Discount Reward (Cart Preview) -->
          <div v-if="rewardPreviewDetails.type === 'discount'" class="mb-3">
            <div class="discount-banner mb-3 p-2 rounded-3 border-0" style="background-color: #fff9c4; color: #fbc02d;">
              <i class="fa-solid fa-percent me-2"></i>
              <span class="fw-bold">Se aplicará un {{ rewardPreviewDetails.discount }}% de descuento a tu carrito</span>
            </div>
            
            <div v-if="cartPreview && cartPreview.length > 0" class="text-start">
              <p class="fw-bold small mb-2 text-center">Productos en tu carrito:</p>
              <div class="cart-preview-list p-2 bg-white rounded-3 border" style="max-height: 200px; overflow-y: auto;">
                <div v-for="item in cartPreview" :key="item.id" class="d-flex align-items-center mb-2 last-child-mb-0">
                  <div v-if="item.photo" class="me-2">
                    <img :src="item.photo" class="rounded-2" style="width: 40px; height: 40px; object-fit: cover;">
                  </div>
                  <div v-else class="me-2">
                    <div class="rounded-2 d-flex align-items-center justify-content-center bg-light border" style="width: 40px; height: 40px;" v-html="noPhoto"></div>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-0 small fw-medium">{{ item.name }}</p>
                    <small class="text-muted">{{ item.amount }} un. x {{ item.price }}€</small>
                  </div>
                </div>
              </div>
              <div class="mt-3 text-center border-top pt-2">
                <p class="mb-0 small text-muted">Total:</p>
                <span class="text-muted text-decoration-line-through me-2 fs-6">{{ previewOriginalTotal.toFixed(2) }}€</span>
                <span class="fw-bold fs-5" style="color: #4caf50;">{{ previewDiscountedTotal.toFixed(2) }}€</span>
              </div>
            </div>
            <div v-else class="text-center py-3 text-muted">
               <div v-if="rewardPreviewDetails.type === 'discount'" class="p-3 rounded-3 border border-warning-subtle" style="background-color: #fff9e6;">
                  <i class="fa-solid fa-cart-shopping mb-2 d-inline-block text-warning" style="font-size: 1.5rem;"></i>
                  <p class="small mb-0 fw-bold text-dark">Tu carrito está vacío</p>
                  <p class="mb-0 text-muted mt-1" style="font-size: 0.8rem;">Añade productos a tu carrito para poder canjear este premio.</p>
               </div>
               <p v-else class="small mb-0">Tu carrito está vacío</p>
            </div>
          </div>
        </div>

        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary w-50 rounded-pill py-3 fw-bold shadow-sm" @click="showRewardPreviewModal = false">
            Cancelar
          </button>
          <button class="btn text-white w-50 rounded-pill py-3 fw-bold shadow-sm" 
                  style="background-color: var(--primary-color); border-color: var(--primary-color)"
                  @click="showFinalConfirmation = true"
                  :disabled="loading || !canRedeemReward">
            Continuar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Global Shared Components -->
  <OrderAlerts 
    :showPlateMaxError="showPlateMaxError"
    :showDeliveryError="showDeliveryError"
    :showClosedKitchetError="showClosedKitchetError"
    :showRestaurantClosedError="showRestaurantClosedError"
    :showError="showError"
    :errorMessage="errorMessage"
  />
  
  <PointsEarnedPopup 
    :visible="showPointsPopup"
    :points="earnedPoints"
  />
  
  <OrderDataModals
    :is_delivery_popup="is_delivery_popup"
    :is_take_away_popup="is_take_away_popup"
    :is_counter_popup="is_counter_popup"
    :is_kiosk_popup="is_kiosk_popup"
    :token="token"
    :userInfo="userInfo"
    :reward_id="rewardPreviewDetails ? rewardPreviewDetails.id : null"
    :plate_reward_id="selectedRewardPlateId"
    @close="closeOrderDataPopUp"
    @success="onOrderDataSuccess"
    @order-error="onOrderError"
    @loading="loading = $event"
  />

  <PagarCuenta 
    v-if="pay_bill" 
    @closePay="pay_bill = false" 
    @PedidoPagado="PedidoPagado"
    @PointsEarned="handlePointsEarned"
    @payError="onPayError"
    :pay_at_order="pay_at_order"
    payment_context="cart"
    :is_counter="is_counter"
    :is_delivery="is_delivery"
    :is_take_away="is_take_away"
    :totalAmount="previewDiscountedTotal"
    :payedAmount="0"
    :payment_method="payment_method"
    :bizum_enabled="bizum_enabled" :tips_enabled="tips_enabled"
    :reward_id="rewardPreviewDetails ? rewardPreviewDetails.id : null"
    :plate_reward_id="selectedRewardPlateId"
  />

  <GoogleReviewPrompt />

</template>

<script>
import { getPartnerToken, getPartnerRefresh } from '@/services/auth/partnerSessionStorage';

  import { mapState } from 'vuex';
  import axios from 'axios';
  import router from '@/router';
  import LlamadaCamarero from '@/components/LlamadaCamarero.vue'
  import { applyRestaurantCustoms, persistRestaurantCustoms } from '@/utils/restaurant_customs.js';
  import noPhoto from '@/assets/no_plate.svg?raw';
  import OrderAlerts from '@/components/OrderAlerts.vue';
  import PointsEarnedPopup from '@/components/PointsEarnedPopup.vue';
  import LoyaltyLoginSuccess from '@/components/LoyaltyLoginSuccess.vue';
  import LoyaltyPreferenceChoices from '@/components/LoyaltyPreferenceChoices.vue';
  import LoyaltyBirthdayField from '@/components/LoyaltyBirthdayField.vue';
  import LoyaltyCommunicationSettings from '@/components/LoyaltyCommunicationSettings.vue';
  import GoogleWalletButton from '@/components/GoogleWalletButton.vue';
  import { isIPhoneDevice, walletPlatform as detectWalletPlatform, walletName } from '@/utils/appleWalletDevice';
  import OrderDataModals from '@/components/OrderDataModals.vue';
  import PagarCuenta from '@/components/PagarCuenta.vue';
  import GoogleReviewPrompt from '@/components/GoogleReviewPrompt.vue';
  import { configureGoogleReview } from '@/services/googleReview';
  import { markCustomerVisitActive, rejectedCustomerSessionRoute } from '@/services/customerVisit';
  import TpvFloatingControls from '@/components/TpvFloatingControls.vue';
  import PwaStatusBanner from '@/components/PwaStatusBanner.vue';
  import LocalContinuityBanner from '@/components/device/LocalContinuityBanner.vue';
  import LocalModeBanner from '@/components/device/LocalModeBanner.vue';
  import VirtualPrintActionManager from '@/components/VirtualPrintActionManager.vue';
  import SecondaryDeviceBlockedOverlay from '@/components/device/SecondaryDeviceBlockedOverlay.vue';
  import StaffPinPrompt from '@/components/staff/StaffPinPrompt.vue';
  import {
    hasUsableLocalHubAuthority,
    shouldOverlayOperationalRoute,
  } from '@/services/device/deviceOperationalPolicy';
  import { handleCreateOrder, processOrderError } from '@/utils/order_handler.js';
  import { isBackendUnavailableError, markBackendUnavailable, shouldUseOfflineMode } from '@/services/connectivity/connectivityService';
  import { getOfflineSession, isOfflineSessionActive } from '@/services/offline/offlineUserAccess';
  import { OFFLINE_MODE_ENABLED } from '@/services/offline/offlineFeature';
  import { setLoadingOverlayPreference } from '@/services/ui/loadingOverlayPreference';
  import { getPartnerProfile } from '@/services/auth/partnerProfileService';
  import { isSessionRevisionPaused } from '@/services/auth/sessionRevisionPause';
  import { synchronizePrintAgentSession } from '@/services/printing/printAgentService';
  import {
    TPV_MENU_ITEMS,
    canAccessTpvPermission,
    getTpvPermissionForPath
  } from '@/utils/tpv_permissions.js';
  import { isTpvPermissionDisabledOffline } from '@/utils/tpv_offline_policy';

  const GOOGLE_TRANSLATE_SRC = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  const AUTHENTICATION_ROUTE_NAMES = new Set(['Login', 'LoginAdmin', 'ChangePass', 'WalletPromotions', 'WalletPersonal', 'LoyaltyPrivacy']);
  let googleTranslateScriptPromise = null;

  function waitForGoogleTranslateApi(timeoutMs = 5000) {
    return new Promise((resolve, reject) => {
      const startedAt = Date.now();
      const checkAvailability = () => {
        if (window.google?.translate?.TranslateElement) {
          resolve();
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          reject(new Error('Google Translate no respondio a tiempo.'));
          return;
        }
        window.setTimeout(checkAvailability, 50);
      };
      checkAvailability();
    });
  }

  function loadGoogleTranslateScript() {
    if (typeof window === 'undefined') {
      return Promise.reject(new Error('Google Translate no está disponible fuera del navegador.'));
    }

    if (window.google?.translate?.TranslateElement) {
      return Promise.resolve();
    }

    if (!googleTranslateScriptPromise) {
      googleTranslateScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${GOOGLE_TRANSLATE_SRC}"]`);
        if (existingScript) {
          waitForGoogleTranslateApi().then(resolve, reject);
          existingScript.addEventListener('error', () => reject(new Error('No se pudo cargar Google Translate.')), { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = GOOGLE_TRANSLATE_SRC;
        script.async = true;
        script.onload = () => waitForGoogleTranslateApi().then(resolve, reject);
        script.onerror = () => reject(new Error('No se pudo cargar Google Translate.'));
        document.head.appendChild(script);
      });
    }

    return googleTranslateScriptPromise.catch((error) => {
      googleTranslateScriptPromise = null;
      throw error;
    });
  }

  function googleTranslateElementInit() {
    if (typeof window === 'undefined' || !window.google?.translate?.TranslateElement) {
      return;
    }

    const translateHost = document.getElementById('google_translate_element');
    if (!translateHost || translateHost.dataset.initialized === 'true') {
      return;
    }

    new window.google.translate.TranslateElement({
      pageLanguage: 'es',
      includedLanguages: 'es,ca,gl,eu,fr,pt,en,ar,ru,uk',
      autoDisplay: false
    }, 'google_translate_element');

    translateHost.dataset.initialized = 'true';
  }

  function waitForGoogleTranslateSelect(timeoutMs = 3000) {
    const existingSelect = document.querySelector('.goog-te-combo');
    if (existingSelect) return Promise.resolve(existingSelect);

    return new Promise((resolve) => {
      const observer = new MutationObserver(() => {
        const select = document.querySelector('.goog-te-combo');
        if (!select) return;
        observer.disconnect();
        clearTimeout(timeoutId);
        resolve(select);
      });
      const timeoutId = window.setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, timeoutMs);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  if (typeof window !== 'undefined') {
    window.googleTranslateElementInit = googleTranslateElementInit;
  }

  export default {
    name: 'App',
    data() {
      return {
        noPhoto,
        carrito: 0,
        loginsFallidos: 0,
        max_plates: null,
        isSidebarVisible: true,
        is_delivery: false,
        is_delivery_popup: false,
        is_take_away: false,
        is_take_away_popup: false,
        is_kiosk: false,
        is_kiosk_popup: false,
        is_counter: false,
        is_counter_popup: false,
        open_kitchen: true,
        ewu_profesional: true,
        accepts_payments: false,
        payment_method: null,
        bizum_enabled: false,
        tips_enabled: true,
        pay_at_order: false,
        pay_at_order_cash_enabled: false,
        // Se sabe si el restaurante cobra al pedir (tras la primera consulta).
        payment_config_loaded: false,
        allow_facturation_bdp: false,
        loyalty_active: false,
        rewards: [],
        restaurant_logo: '',
        restaurant_name: '',
        restaurantLogoIsCompact: false,
        delivery_name: '',
        // Loyalty state
        showUserDataModal: false,
        showLoyaltySuccess: false,
        loyaltySuccessKind: '',
        userData: {
          email: '',
          name: '',
          phone: ''
        },
        registrationLegal: null,
        registrationPreferences: { communications_email: false, marketing_email: false, wallet_proximity: false, terms_accepted: false, birthday_email: false, birthday_day: null, birthday_month: null },
        preferencesReviewRequired: false,
        registrationStep: 1,
        registrationCode: '',
        registrationError: '',
        loading: false,
        isUserCardLoggedIn: false,
        hasSkipped: sessionStorage.getItem('userDataSkipped') === 'true',
        userPoints: 0,
        translateError: '',
        productRewardProgress: {},
        showRewardsDrawer: false,
        walletStage: 'idle',
        walletBusy: false,
        walletCode: '',
        walletError: '',
        walletVerifiedUntil: 0,
        showRewardPreviewModal: false,
        rewardPreviewDetails: null,
        selectedRewardPlateId: null,
        isRedeemedSuccess: false,
        cartPreview: null,
        previewMode: null,
        showFinalConfirmation: false,
        showPlateMaxError: false,
        showDeliveryError: false,
        showClosedKitchetError: false,
        showRestaurantClosedError: false,
        showError: false,
        errorMessage: '',
        showPointsPopup: false,
        earnedPoints: 0,
        userInfo: {
          name: localStorage.getItem('user_email') ? null : '', // Try to prepopulate if needed?
          address: null,
          email: localStorage.getItem('user_email') || null,
          additionalInfo: null,
          piso: null,
          codPostal: null,
          latitude: null,
          longitude: null,
          payWithCard: null,
        },
        pay_bill: false,
        dockExpanded: false,
        currentPartnerUser: null,
        operationalViewKey: 0,
        pollingInterval: null,
        handleCartCountChanged: null,
      }
    },
    components: {
      GoogleReviewPrompt,
      LlamadaCamarero,
      OrderAlerts,
      PointsEarnedPopup,
      LoyaltyLoginSuccess,
      LoyaltyPreferenceChoices,
      LoyaltyBirthdayField,
      LoyaltyCommunicationSettings,
      GoogleWalletButton,
      OrderDataModals,
      PagarCuenta,
      TpvFloatingControls,
      PwaStatusBanner,
      LocalContinuityBanner,
      LocalModeBanner,
      VirtualPrintActionManager,
      SecondaryDeviceBlockedOverlay,
      StaffPinPrompt
    },
    computed:{
        ...mapState(['isLoggedIn']),
        ...mapState(['token']),
        ...mapState(['partner_token']),
        ...mapState(['refresh']),
        ...mapState(['isWaiterMode']),
        offlineModeEnabled() {
          return OFFLINE_MODE_ENABLED
        },
        customerSectionTitle() {
          if (!this.$route.meta.showFooter) return '';
          return { Carrito: 'Carrito', MisPedidos: 'Mis pedidos', Cuenta: 'Cuenta' }[this.$route.name] || '';
        },
        virtualPrintManagerEnabled() {
          return Boolean(this.$route.meta.partnerMenu || this.$route.meta.tpvHub)
        },
        showSecondaryDeviceBlockedOverlay() {
          if (process.env.VUE_APP_HIDE_DEVICE_BLOCK_OVERLAY === 'true') return false;
          return Boolean(
            this.$store.state.device.blockedByDevicePolicy
            && !hasUsableLocalHubAuthority(this.$store.state)
            && shouldOverlayOperationalRoute(this.$route)
          )
        },
        showTpvDock() {
          if (this.$route.name === 'TPVHub') return false
          return Boolean(this.$route.meta.partnerMenu || this.$route.meta.tpvHub)
        },
        partnerDockItems() {
          return TPV_MENU_ITEMS
            .filter((item) => item.route && canAccessTpvPermission(this.currentPartnerUser, item.id))
            .filter((item) => !(shouldUseOfflineMode() && isTpvPermissionDisabledOffline(item.id)))
            .map((item) => ({
              label: item.dockLabel || item.title,
              icon: item.icon,
              route: item.route
            }))
        },
        showTranslateButton() {
          return !['/', '/login', '/LoginAdmin'].includes(this.$route.path) && !this.$route.meta.noTranslate
        },
        shouldLiftTranslateButton() {
          return ['Home', 'Carrito', 'MisPedidos', 'Cuenta'].includes(this.$route.name)
        },
        requiresPayment() {
          return this.pay_at_order &&
                 this.rewardPreviewDetails?.type === 'discount' &&
                 this.previewDiscountedTotal > 0;
        },
        selectedRewardPlateName() {
          if (this.rewardPreviewDetails?.plate) return this.rewardPreviewDetails.plate.name;
          const selectedPlate = (this.rewardPreviewDetails?.plates || []).find(
            plate => plate.id === this.selectedRewardPlateId
          );
          return selectedPlate?.name || 'tu producto gratis';
        },
        isFormValid() {
          if (this.registrationStep === 1) {
            return this.userData.email.trim() !== '' && /^\S+@\S+\.\S+$/.test(this.userData.email);
          }
          if (this.registrationStep === 3) {
            return /^\d{6}$/.test(this.registrationCode);
          }
          return this.userData.name.trim() !== '' && Boolean(this.registrationLegal) && (!this.registrationLegal.terms_required || this.registrationPreferences.terms_accepted);
        },
        previewOriginalTotal() {
          if (!this.cartPreview) return 0;
          let total = 0;
          const mode = this.previewMode;

          if (!mode || !mode.is2x1) {
            this.cartPreview.forEach(plate => {
              const stepSupplements = (plate.steps || []).reduce((sum, step) => {
                const stepSum = (step.plates_selected || []).reduce((s, p) => {
                  const val = Number(p?.supplement ?? 0);
                  return s + (Number.isFinite(val) ? val : 0);
                }, 0);
                return sum + stepSum;
              }, 0);
              total += (plate.price + stepSupplements) * plate.amount;
            });
            return total;
          }

          const categories2x1 = mode.excluded_categories.map(c => c.id);
          const grouped = {};

          this.cartPreview.forEach(plate => {
            const stepSupplements = (plate.steps || []).reduce((sum, step) => {
              const stepSum = (step.plates_selected || []).reduce((s, p) => {
                const val = Number(p?.supplement ?? 0);
                return s + (Number.isFinite(val) ? val : 0);
              }, 0);
              return sum + stepSum;
            }, 0);

            const unitPrice = plate.price + stepSupplements;

            if (!categories2x1.includes(plate.category_id)) {
              total += unitPrice * plate.amount;
              return;
            }

            if (!grouped[plate.category_id]) {
              grouped[plate.category_id] = [];
            }

            for (let i = 0; i < plate.amount; i++) {
              grouped[plate.category_id].push(unitPrice);
            }
          });

          for (const categoryId in grouped) {
            const prices = grouped[categoryId].sort((a, b) => b - a);
            const itemsToCharge = prices.length - Math.floor(prices.length / 2);
            total += prices.slice(0, itemsToCharge).reduce((sum, price) => sum + price, 0);
          }

          return Math.round(total * 100) / 100;
        },
        previewDiscountedTotal() {
          const total = this.previewOriginalTotal;
          if (!this.rewardPreviewDetails || this.rewardPreviewDetails.type !== 'discount') return total;
          const discount = this.rewardPreviewDetails.discount || 0;
          return Math.round(total * (1 - discount / 100) * 100) / 100;
        },
        canRedeemReward() {
          if (!this.rewardPreviewDetails) return false;
          
          // Discount reward needs items in cart
          if (this.rewardPreviewDetails.type === 'discount') {
            return this.cartPreview && this.cartPreview.length > 0;
          }
          
          // Product reward with selection needs a plate selected
          if (this.rewardPreviewDetails.plates && this.rewardPreviewDetails.plates.length > 0) {
            return !!this.selectedRewardPlateId;
          }
          
          return true;
        },
        isIPhone() {
          return isIPhoneDevice();
        },
        walletPlatform() {
          return detectWalletPlatform();
        },
        walletDisplayName() {
          return walletName(this.walletPlatform);
        },
        orderedRewards() {
          if (!this.rewards) return [];
          return [...this.rewards].sort((a, b) => (a.necessary_points || 0) - (b.necessary_points || 0));
        }
    },
    methods:{
      onCustomerHeaderLogoLoad(event) {
        const { naturalWidth, naturalHeight } = event.target;
        this.restaurantLogoIsCompact = naturalHeight > 0 && naturalWidth / naturalHeight < 1.5;
      },
      syncPrintAgentToken(token) {
        return synchronizePrintAgentSession({ partnerToken: token })
          .catch((error) => ({ ok: false, error: error?.message || 'No se pudo actualizar la prueba de impresion.' }));
      },
      handleOperationalAccessBlocked() {
        if (!this.$store.state.device.blockedByDevicePolicy) return;
        if (hasUsableLocalHubAuthority(this.$store.state)) return;
        if (!shouldOverlayOperationalRoute(this.$route)) return;
        // Remount the active operational view behind the overlay to discard any
        // component-local optimistic mutation that the server did not accept.
        this.operationalViewKey += 1;
      },
      async handleOperationalAccessRestored() {
        if (!shouldOverlayOperationalRoute(this.$route)) return;
        const token = this.$store.state.partner_token;
        if (token) {
          try {
            this.currentPartnerUser = await getPartnerProfile({
              token,
              force: true,
              timeoutMs: 5000,
            });
          } catch (error) {
            console.warn('Unable to refresh Partner context after operational unlock:', error);
          }
        }
        this.operationalViewKey += 1;
      },
      logout() {
        this.$store.commit('logout');
      },
      OpenCallWaiter(){
        document.getElementById("waiter_call").classList.remove("d-none")
      },
      ReviseSession() {
        if (document.visibilityState === 'hidden' || isSessionRevisionPaused()) return Promise.resolve(null);
        if (this._reviseSessionPromise) return this._reviseSessionPromise;
        this._reviseSessionPromise = this.performSessionRevision()
          .finally(() => {
            this._reviseSessionPromise = null;
          });
        return this._reviseSessionPromise;
      },
      async performSessionRevision(){
        // La pantalla de acceso no tiene una sesión que refrescar. Evita que
        // el ciclo global de sesión haga peticiones o provoque transiciones
        // mientras el usuario está rellenando el formulario.
        if (AUTHENTICATION_ROUTE_NAMES.has(this.$route.name)) return;
        if (this.$route.meta.authorized){
          if (this.token != "null" && this.token != null){
            const token = this.token; 
            const url = process.env.VUE_APP_API_URL + '/v1/api/app/me_table';
            try {
              const response = await axios.get(url, {
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
              this.loginsFallidos = 0;
              markCustomerVisitActive();
              this.carrito = response.data.shopping_cart_amount;
              this.is_delivery = response.data.is_delivery;
              this.is_take_away = response.data.is_take_away;
              this.max_plates = response.data.max_plates;
              this.open_kitchen = response.data.open_kitchen;
              this.accepts_payments = response.data.accepts_payments;
              this.payment_method = response.data.payment_method || null;
              this.bizum_enabled = Boolean(response.data.bizum_enabled);
              this.tips_enabled = response.data.tips_enabled !== false;
              this.is_kiosk = response.data.is_kiosk;
              this.is_counter = response.data.is_counter;
              this.delivery_name = response.data.delivery_name;
              this.pay_at_order = response.data.pay_at_order;
              this.pay_at_order_cash_enabled = Boolean(response.data.pay_at_order_cash_enabled);
              this.payment_config_loaded = true;
              this.allow_facturation_bdp = response.data.allow_facturation_bdp;
              this.loyalty_active = response.data.loyalty_active;
              this.rewards = response.data.rewards || [];
              this.userPoints = response.data.points || 0;
              localStorage.setItem('user_points', response.data.points || 0);

              this.restaurant_logo = response.data.restaurant?.customization?.logo || '';
              this.restaurant_name = response.data.restaurant?.name || '';
              // Reseña en Google al terminar (null si el restaurante no la pide).
              configureGoogleReview({
                url: this.is_kiosk ? null : response.data.google_review_url,
                restaurantName: this.restaurant_name,
                payBeforeEating: Boolean(this.pay_at_order || this.is_counter || this.is_take_away || this.is_delivery),
                visitKey: token,
              });
              if (response.data.restaurant.customization) {
                const customization = response.data.restaurant.customization;
                await persistRestaurantCustoms({
                  primary_color: customization.primary_color || null,
                  secondary_color: customization.secondary_color || null,
                  customer_background_color: customization.customer_background_color || null,
                });
                applyRestaurantCustoms();
              }

              this.$store.dispatch('setUserAllowedToCancel', response.data.restaurant.user_allowed_to_cancel_order);
            } catch (error) {
              // Sin respuesta tampoco se bloquea el carrito: si el restaurante
              // cobra al pedir, el servidor lo dirá al pedir.
              this.payment_config_loaded = true;
              if (isSessionRevisionPaused()) return;
              const responseStatus = Number(error?.response?.status);
              const accessCode = error?.response?.data?.detail?.code;
              if (responseStatus === 403 && accessCode === 'restaurant_selection_required') {
                router.push({ name: 'Login', query: { selectRestaurant: '1' } });
                return;
              }
              if (responseStatus === 403 && accessCode === 'restaurant_access_revoked') {
                this.$store.commit('logout');
                router.push({ name: 'Login' });
                return;
              }
              if (isBackendUnavailableError(error)) {
                markBackendUnavailable(error?.message || 'No se pudo actualizar la sesión online.');
                this.loginsFallidos = 0;
                return;
              }

              if (responseStatus === 401 || responseStatus === 403) {
                this.loginsFallidos++;
                if (this.loginsFallidos > 0) {
                  if(!this.is_kiosk){
                    // Si la mesa estaba abierta hace poco, se ha cerrado (cobrada o
                    // liberada por el personal): pantalla de agradecimiento.
                    router.push(rejectedCustomerSessionRoute());
                  }else{
                    router.push(`/Quiosco/${this.delivery_name}`)
                  }
                }
                console.warn('Session update rejected by API:', error);
                return;
              }

              // Un error 5xx del servidor no invalida la sesión del cliente.
              this.loginsFallidos = 0;
              console.error('Error fetching shopping cart:', error);
            }
          } else {
            this.loginsFallidos++;
            if (this.loginsFallidos > 0) {
              router.push({ name: "Unauthorized" });
            }
          }
        }else if(this.$route.meta.showFooterWaiter || this.$route.meta.partnerMenu || this.$route.meta.tpvHub){
          const offlineSession = OFFLINE_MODE_ENABLED && isOfflineSessionActive() ? getOfflineSession() : null;
          if (offlineSession && shouldUseOfflineMode()) {
            this.currentPartnerUser = offlineSession;
            this.loginsFallidos = 0;
            this.$store.dispatch('setUserAllowedToCancel', Boolean(offlineSession.user_allowed_to_cancel));
            this.enforceTpvPermissions();
            return;
          }

          if (this.partner_token != "null" && this.partner_token != null){
            try {
              const partnerProfile = await getPartnerProfile({
                token: this.partner_token,
                force: true,
                timeoutMs: 5000,
              });
              if (isSessionRevisionPaused()) return;
              this.ewu_profesional = partnerProfile.ewu_profesional !== false
              // El plan y los permisos TPV se verifican en el guard y en
              // enforceTpvPermissions. Este indicador solo controla opciones
              // de Ajustes; no debe expulsar una mesa activa cada minuto.

              this.currentPartnerUser = partnerProfile;
              this.$store.commit('device/setUserIsPartner', partnerProfile.is_partner);
              this.$store.commit('device/setPartnerContext', partnerProfile);
              setLoadingOverlayPreference(
                partnerProfile.show_loading_overlays,
                partnerProfile.restaurant_id || null
              );

              if (partnerProfile.restaurant_logo) {
                this.restaurant_logo = `${partnerProfile.restaurant_logo}?t=${new Date().getTime()}`;
              } else {
                this.restaurant_logo = null;
              }

              this.$store.dispatch('setUserAllowedToCancel', partnerProfile.user_allowed_to_cancel);
              sessionStorage.setItem('partner_first_name', partnerProfile.first_name);
              this.enforceTpvPermissions();
              //console.log(response.data.user_allowed_to_cancel)
            } catch (error) {
              const responseStatus = Number(error?.response?.status);
              if (isBackendUnavailableError(error)) {
                markBackendUnavailable(error?.message || 'No se pudo actualizar la sesión online.');
                this.loginsFallidos = 0;
                return;
              }

              if (responseStatus === 401) {
                const refreshToken = this.refresh;
                if (!refreshToken || refreshToken === 'null') {
                  this.$store.commit('logout');
                  router.push({ name: 'Login' });
                  return;
                }
                const accessBeforeRefresh = this.partner_token;
                try {
                  const response = await axios.post(
                    `${process.env.VUE_APP_API_URL}/v1/api/partner/refresh`,
                    { refresh: refreshToken },
                    { headers: { 'Content-Type': 'application/json' } },
                  );
                  if (getPartnerToken() !== accessBeforeRefresh || getPartnerRefresh() !== refreshToken) return;
                  if (response.data.selection_required) {
                    this.$store.commit('login', response.data);
                    router.push({ name: 'Login', query: { selectRestaurant: '1' } });
                    return;
                  }
                  await this.$store.dispatch('setToken', response.data);
                  this.syncPrintAgentToken(response.data?.access);
                  this.loginsFallidos = 0;
                } catch (refreshError) {
                  const refreshStatus = Number(refreshError?.response?.status);
                  if (refreshStatus === 401) {
                    if (isSessionRevisionPaused()
                      || this.partner_token !== accessBeforeRefresh
                      || this.refresh !== refreshToken
                      || getPartnerToken() !== accessBeforeRefresh
                      || getPartnerRefresh() !== refreshToken) return;
                    this.$store.commit('logout');
                    router.push({ name: 'Login' });
                    return;
                  }
                  if (isBackendUnavailableError(refreshError)) {
                    markBackendUnavailable(refreshError?.message || 'No se pudo refrescar la sesión online.');
                  }
                  console.warn('No se pudo refrescar la sesión Partner. Se conserva para reintentar.', refreshError);
                }
                return;
              }

              // Una denegación puntual o un error del servidor no prueban que
              // hayan caducado las credenciales. El siguiente ciclo reintentará.
              console.warn('No se pudo comprobar la sesión Partner. Se conserva para reintentar.', error);
              return;
            }
          }else{
            this.loginsFallidos++
            if (this.loginsFallidos > 0){
              router.push({ name: "Login" });
            }
          }
        }
      },
      enforceTpvPermissions() {
        const requiredPermission = getTpvPermissionForPath(this.$route.path);
        if (!requiredPermission) return;

        if (!canAccessTpvPermission(this.currentPartnerUser, requiredPermission)) {
          this.$router.push({ name: "TPVHub" });
        }
      },
      startPolling() {
        if (AUTHENTICATION_ROUTE_NAMES.has(this.$route.name)) return;
        this.ReviseSession();
        const intervalMs = this.$route.meta.authorized ? 15000 : 60000;
        this.pollingInterval = setInterval(this.ReviseSession, intervalMs);
      },
      stopPolling() {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      },
      toggleSidebar() {
        this.isSidebarVisible = !this.isSidebarVisible;
        document.body.classList.toggle('no-scroll', this.isSidebarVisible);
      },
      async translate(lang) {
        this.translateError = '';
        if (!['es', 'ca', 'gl', 'eu', 'fr', 'pt', 'en', 'ar', 'ru', 'uk'].includes(lang)) return;

        // El widget restaura el idioma desde la cookie al cargar la pagina.
        // Para volver al original hay que limpiar sus dos variantes y recargar.
        if (lang === 'es') {
          document.cookie = 'googtrans=; max-age=0; path=/; domain=.ewu.es';
          document.cookie = 'googtrans=; max-age=0; path=/';
          window.location.reload();
          return;
        }

        try {
          await loadGoogleTranslateScript();
          googleTranslateElementInit();
          const translateSelect = await waitForGoogleTranslateSelect(5000);
          if (!translateSelect || !Array.from(translateSelect.options).some((option) => option.value === lang)) {
            throw new Error('El selector de idiomas de Google Translate no esta disponible.');
          }

          const host = location.hostname;
          const cookieAttrs = [
            'path=/',
            ...(host.endsWith('ewu.es') ? ['domain=.ewu.es'] : []),
            ...(location.protocol === 'https:' ? ['SameSite=None', 'Secure'] : [])
          ].join('; ');
          document.cookie = 'googtrans=; max-age=0; path=/; domain=.ewu.es';
          document.cookie = 'googtrans=; max-age=0; path=/';
          document.cookie = `googtrans=/es/${lang}; max-age=${60 * 60 * 24 * 365}; ${cookieAttrs}`;

          translateSelect.value = lang;
          translateSelect.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (error) {
          this.translateError = 'La traducción no está disponible ahora. Inténtalo de nuevo.';
          console.warn('No se pudo traducir la carta:', error);
        }
      },
      // Loyalty methods
      async requestWalletCode() {
        this.walletError = '';
        if (!this.token || !this.isUserCardLoggedIn) {
          this.walletError = 'Inicia sesión en fidelización para añadir tu tarjeta.';
          return;
        }
        this.walletBusy = true;
        try {
          this.walletVerifiedUntil = 0;
          await axios.post(process.env.VUE_APP_API_URL + '/v1/api/wallet/customer/request-code', { platform: this.walletPlatform || 'apple' }, {
            headers: { Authorization: 'Bearer ' + this.token }
          });
          this.walletStage = 'sent';
          this.walletCode = '';
          await this.$nextTick();
          this.$refs.walletCodeInput?.focus();
        } catch (error) {
          this.walletError = error.response?.data?.error || 'No se pudo enviar el código.';
        } finally {
          this.walletBusy = false;
        }
      },
      async completeWallet() {
        if (!/^\d{6}$/.test(this.walletCode) || this.walletBusy) return;
        this.walletBusy = true;
        this.walletError = '';
        const base = process.env.VUE_APP_API_URL;
        const headers = { Authorization: 'Bearer ' + this.token };
        try {
          // verify-code consumes the code; the email proof stays valid for 15 min, so a
          // retry after a failed issue (e.g. Google temporarily unavailable) skips it.
          if (Date.now() >= this.walletVerifiedUntil) {
            await axios.post(base + '/v1/api/wallet/customer/verify-code', { code: this.walletCode }, { headers });
            this.walletVerifiedUntil = Date.now() + 14 * 60 * 1000;
          }
          const google = this.walletPlatform === 'google';
          const response = await axios.post(base + (google ? '/v1/api/wallet/customer/google' : '/v1/api/wallet/customer/issue'), {}, { headers });
          this.walletStage = 'idle';
          this.walletCode = '';
          // Google returns an absolute pay.google.com link; Apple a one-use relative download.
          window.location.assign(google ? response.data.url : base + response.data.url);
        } catch (error) {
          if ([401, 403].includes(error.response?.status)) this.walletVerifiedUntil = 0;
          this.walletError = error.response?.data?.error || 'No se pudo preparar tu tarjeta. Inténtalo de nuevo.';
        } finally {
          this.walletBusy = false;
        }
      },
      closeUserDataModal() {
        this.showUserDataModal = false;
        this.registrationCode = '';
        this.registrationError = '';
        this.hasSkipped = true;
        sessionStorage.setItem('userDataSkipped', 'true');
      },
      async saveUserData() {
        if (this.registrationStep === 1) {
          await this.checkClientLoyalty();
        } else if (this.registrationStep === 2) {
          await this.requestRegistrationCode();
        } else {
          await this.registerClientLoyalty();
        }
      },
      editLoyaltyRegistrationEmail() {
        this.registrationStep = 1;
        this.registrationCode = '';
        this.registrationError = '';
      },
      completeLoyaltySignIn(customer, kind) {
        const points = Number(customer.points) || 0;
        localStorage.setItem('user_email', customer.email);
        localStorage.setItem('user_phone', customer.phone_number || '');
        localStorage.setItem('user_points', points);
        sessionStorage.removeItem('userDataSkipped');
        this.userPoints = points;
        this.setProductRewardProgress(customer.product_reward_progress);
        this.userData.email = customer.email;
        this.userData.name = customer.name || '';
        this.userData.phone = customer.phone_number || '';
        this.hasSkipped = false;
        this.isUserCardLoggedIn = true;
        this.showUserDataModal = false;
        this.registrationStep = 1;
        this.registrationCode = '';
        this.registrationError = '';
        this.walletStage = 'idle';
        this.walletCode = '';
        this.walletError = '';
        this.loyaltySuccessKind = kind;
        this.showLoyaltySuccess = true;
        this.preferencesReviewRequired = false;
        axios.get(process.env.VUE_APP_API_URL + '/v1/api/app/loyalty/preferences', { headers: { Authorization: 'Bearer ' + this.token } })
          .then(response => {
            const key = 'ewu-preference-invitation:' + response.data.restaurant_id + ':' + response.data.account_reference;
            let dismissed = false;
            try { dismissed = localStorage.getItem(key) === 'true'; } catch { /* Preferencia de aviso local no disponible. */ }
            this.preferencesReviewRequired = response.data.review_required && !dismissed;
          }).catch(() => {});
      },
      viewRewardsFromSuccess() {
        this.showLoyaltySuccess = false;
        this.openRewardsDrawer();
      },
      async addWalletFromSuccess() {
        this.showLoyaltySuccess = false;
        this.showRewardsDrawer = true;
        await this.$nextTick();
        await this.requestWalletCode();
      },
      async checkClientLoyalty() {
        this.loading = true;
        const url = process.env.VUE_APP_API_URL + '/v1/api/app/check-client-loyalty?email=' + encodeURIComponent(this.userData.email);
        try {
          const response = await axios.get(url, {
            headers: { 'Authorization': `Bearer ${this.token}` }
          });
          
          this.completeLoyaltySignIn(response.data, 'existing');
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.registrationStep = 2;
            this.registrationPreferences = { communications_email: false, marketing_email: false, wallet_proximity: false, terms_accepted: false, birthday_email: false, birthday_day: null, birthday_month: null };
            await this.loadRegistrationLegal();
          } else {
            console.error('Error checking client:', error);
          }
        } finally {
          this.loading = false;
        }
      },
      async loadRegistrationLegal() {
        this.registrationLegal = null;
        try {
          const response = await axios.get(process.env.VUE_APP_API_URL + '/v1/api/app/loyalty/legal', { headers: { Authorization: 'Bearer ' + this.token } });
          this.registrationLegal = response.data.legal;
        } catch { this.registrationError = 'No se pudo cargar la información de privacidad. Vuelve a intentarlo.'; }
      },
      async openLoyaltyPreferences() {
        this.showLoyaltySuccess = false;
        await this.openRewardsDrawer();
        await this.$nextTick();
        this.$refs.communicationSettings?.openSettings();
        this.$refs.communicationSettings?.$el?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      },
      async requestRegistrationCode() {
        this.loading = true;
        this.registrationError = '';
        const url = process.env.VUE_APP_API_URL + '/v1/api/app/request-client-loyalty-registration-code';
        try {
          await axios.post(url, {
            email: this.userData.email,
            name: this.userData.name,
            phone_number: this.userData.phone,
            ...(this.registrationLegal?.ask_birth_date ? { birthday_day: this.registrationPreferences.birthday_day, birthday_month: this.registrationPreferences.birthday_month } : {}),
            communications_email: this.registrationPreferences.communications_email === true,
            terms_accepted: this.registrationLegal?.terms_url && this.registrationLegal?.terms_version ? this.registrationPreferences.terms_accepted : undefined,
            ...(this.walletPlatform ? { wallet_proximity: this.registrationPreferences.wallet_proximity } : {}),
            legal_revision: this.registrationLegal?.revision || ''
          }, { headers: { Authorization: 'Bearer ' + this.token } });
          this.registrationStep = 3;
          this.registrationCode = '';
          await this.$nextTick();
          this.$refs.loyaltyRegistrationCodeInput?.focus();
        } catch (error) {
          this.registrationError = error.response?.data?.error || 'No se pudo enviar el código. Inténtalo de nuevo.';
        } finally {
          this.loading = false;
        }
      },
      async registerClientLoyalty() {
        this.loading = true;
        this.registrationError = '';
        const url = process.env.VUE_APP_API_URL + '/v1/api/app/register-client-loyalty';
        try {
          const params = {
            email: this.userData.email,
            code: this.registrationCode
          };
          const response = await axios.post(url, params, {
            headers: { 'Authorization': `Bearer ${this.token}` }
          });
          
          this.completeLoyaltySignIn(response.data, 'registered');
        } catch (error) {
          this.registrationError = error.response?.data?.error || 'No se pudo completar el registro. Inténtalo de nuevo.';
        } finally {
          this.loading = false;
        }
      },
      checkLoyaltyPopup() {
        if (!this.loyalty_active) return;
        const hasData = localStorage.getItem('user_email') || localStorage.getItem('user_phone');
        
        if (!this.hasSkipped && !hasData) {
           setTimeout(() => {
             this.showUserDataModal = true;
           }, 1000);
        } else if (hasData) {
          this.isUserCardLoggedIn = true;
          this.userData.email = localStorage.getItem('user_email') || '';
          const points = localStorage.getItem('user_points');
          if (points) {
            this.userPoints = parseInt(points);
          }
        }
      },
      logoutLoyalty() {
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_phone');
        localStorage.removeItem('user_points');
        sessionStorage.removeItem('userDataSkipped');

        this.userPoints = 0;
        this.productRewardProgress = {};
        this.isUserCardLoggedIn = false;
        this.userData.email = '';
        this.userData.name = '';
        this.userData.phone = '';
        this.registrationStep = 1;
        this.registrationCode = '';
        this.registrationError = '';
        this.showRewardsDrawer = false;
        this.showLoyaltySuccess = false;
        this.loyaltySuccessKind = '';
        this.walletStage = 'idle';
        this.walletCode = '';
        this.walletError = '';
        this.hasSkipped = false;

        setTimeout(() => {
            this.showUserDataModal = true;
        }, 350);
      },
      setProductRewardProgress(progress = []) {
        this.productRewardProgress = Object.fromEntries(
          (progress || []).map(item => [item.reward_id, item])
        );
      },
      getRewardProgress(rewardId, buyQuantity = 1) {
        return this.productRewardProgress[rewardId] || {
          qualifying_units: 0,
          available_count: 0,
          units_to_next: buyQuantity || 1
        };
      },
      canRedeemRewardFromList(reward) {
        if (reward.type === 'buy_x_get_y') {
          return this.getRewardProgress(reward.id, reward.buy_quantity).available_count > 0;
        }
        return this.userPoints >= (reward.necessary_points || 0);
      },
      productRewardStatusText(reward) {
        const progress = this.getRewardProgress(reward.id, reward.buy_quantity);
        if (progress.available_count > 0) {
          return progress.available_count + ' producto' + (progress.available_count === 1 ? '' : 's') +
            ' gratis disponible' + (progress.available_count === 1 ? '' : 's');
        }
        const purchasedTowardNext = progress.qualifying_units % (reward.buy_quantity || 1);
        return 'Progreso: ' + purchasedTowardNext + '/' + reward.buy_quantity +
          ' · Te faltan ' + progress.units_to_next;
      },
      rewardProgressTarget(reward) {
        const target = reward.type === 'buy_x_get_y' ? reward.buy_quantity : reward.necessary_points;
        return Math.max(0, Number(target) || 0);
      },
      rewardProgressCurrent(reward) {
        const target = Math.max(this.rewardProgressTarget(reward), 1);
        if (reward.type === 'buy_x_get_y') {
          const progress = this.getRewardProgress(reward.id, target);
          if (progress.available_count > 0) return target;
          return Math.max(0, Number(progress.qualifying_units) || 0) % target;
        }
        return Math.min(target, Math.max(0, Number(this.userPoints) || 0));
      },
      rewardProgressPercent(reward) {
        const target = this.rewardProgressTarget(reward);
        return target ? Math.min(100, Math.round(this.rewardProgressCurrent(reward) / target * 100)) : 100;
      },
      rewardProgressUnit(reward) {
        return reward.type === 'buy_x_get_y' ? 'unidades' : 'puntos';
      },
      rewardProgressStatusText(reward) {
        if (this.canRedeemRewardFromList(reward)) {
          return reward.type === 'buy_x_get_y' ? '¡Has desbloqueado tu regalo!' : '¡Meta alcanzada!';
        }
        if (reward.type === 'buy_x_get_y') {
          const progress = this.getRewardProgress(reward.id, reward.buy_quantity);
          const remaining = Math.max(0, Number(progress.units_to_next) || this.rewardProgressTarget(reward));
          return `Te faltan ${remaining} ${remaining === 1 ? 'compra' : 'compras'} para el siguiente regalo`;
        }
        const remaining = Math.max(0, this.rewardProgressTarget(reward) - (Number(this.userPoints) || 0));
        return `Te faltan ${remaining} ${remaining === 1 ? 'punto' : 'puntos'} para desbloquearla`;
      },
      rewardUnlockedText(reward) {
        if (reward.type === 'buy_x_get_y') {
          const count = this.getRewardProgress(reward.id, reward.buy_quantity).available_count;
          return `${count} regalo${count === 1 ? '' : 's'} disponible${count === 1 ? '' : 's'}`;
        }
        return 'Recompensa desbloqueada';
      },
      rewardKindLabel(reward) {
        if (reward.type === 'buy_x_get_y') return 'Regalo por compra';
        if (reward.type === 'discount') return 'Descuento';
        return 'Producto gratis';
      },
      rewardKindClass(reward) {
        return this.canRedeemRewardFromList(reward) ? 'is-ready' : '';
      },
      rewardKindIcon(reward) {
        if (reward.type === 'buy_x_get_y') return 'fa-basket-shopping';
        if (reward.type === 'discount') return 'fa-percent';
        return 'fa-gift';
      },
      rewardTargetLabel(reward) {
        return reward.reward_target_label || 'producto gratis';
      },
      async openRewardsDrawer() {
        this.showRewardsDrawer = true;
        const email = this.userData.email || localStorage.getItem('user_email');
        if (!email || !this.token) return;
        const url = process.env.VUE_APP_API_URL + '/v1/api/app/check-client-loyalty?email=' + encodeURIComponent(email);
        try {
          const response = await axios.get(url, {
            headers: { 'Authorization': 'Bearer ' + this.token }
          });
          this.userPoints = response.data.points || 0;
          localStorage.setItem('user_points', this.userPoints);
          this.setProductRewardProgress(response.data.product_reward_progress);
          this.$refs.communicationSettings?.load();
        } catch (error) {
          console.error('Error refreshing loyalty rewards:', error);
        }
      },
      async redeemReward(reward) {
        this.loading = true;
        const url = process.env.VUE_APP_API_URL + '/v1/api/app/get_reward_details?reward_id=' + reward.id;
        try {
          const response = await axios.get(url, {
            headers: { 'Authorization': `Bearer ${this.token}` }
          });
          
          console.log('Reward preview details:', response.data);
          this.rewardPreviewDetails = response.data;
          this.selectedRewardPlateId = null;
          if (response.data.plate){
            this.selectedRewardPlateId = response.data.plate.id;
          }
          this.isRedeemedSuccess = false;
          this.showFinalConfirmation = false;
          this.cartPreview = null;

          // If it's a discount, fetch the cart
          if (this.rewardPreviewDetails.type === 'discount') {
            const cartUrl = process.env.VUE_APP_API_URL + '/v1/api/app/ShoppingCart';
            try {
              const cartResponse = await axios.get(cartUrl, {
                headers: { 'Authorization': `Bearer ${this.token}` }
              });
              
              const mode = cartResponse.data.mode;
              const rawPlates = cartResponse.data.shopping_carts || [];
              
              // Process plates like Carrito.vue to handle supplements and mode discounts
              let processedPlates = [];
              rawPlates.forEach(shopping_cart => {
                let plate_structure = {
                  id: shopping_cart.id,
                  plate_id: shopping_cart.plate.id,
                  name: shopping_cart.plate.name,
                  category_id: shopping_cart.plate.category.id,
                  photo: shopping_cart.plate.photo,
                  price: shopping_cart.plate.price,
                  amount: shopping_cart.amount,
                  steps: shopping_cart.plate.steps || []
                };

                let i = 0;
                plate_structure.steps.forEach(step => {
                  // Link selected supplements
                  step.plates_selected = (shopping_cart.steps_selected && shopping_cart.steps_selected[i]) ? shopping_cart.steps_selected[i].plates : [];
                  i++;
                });

                // Apply percentage mode discount if applicable
                if (mode && mode.discount && !mode.excluded_categories.some(cat => cat.id === plate_structure.category_id)) {
                  plate_structure.price *= (100 - mode.discount) / 100;
                  plate_structure.price = Math.round(plate_structure.price * 100) / 100;
                }
                processedPlates.push(plate_structure);
              });

              this.cartPreview = processedPlates;
              this.previewMode = mode;
            } catch (cartError) {
              console.error('Error fetching cart for reward preview:', cartError);
            }
          }
          
          this.showRewardsDrawer = false;
          this.showRewardPreviewModal = true;
        } catch (error) {
          console.error('Error fetching reward details:', error);
          alert('Hubo un error al obtener los detalles de la recompensa. Por favor, inténtalo de nuevo.');
        } finally {
          this.loading = false;
        }
      },
      async finalizeRedemption() {
        if (this.rewardPreviewDetails.plates && this.rewardPreviewDetails.plates.length > 0 && !this.selectedRewardPlateId) {
          alert('Por favor selecciona un plato para canjear tu recompensa.');
          return;
        }

        const params = {
          reward_id: this.rewardPreviewDetails.id,
        };
        if (this.selectedRewardPlateId) {
          params.plate_reward_id = this.selectedRewardPlateId;
        }

        this.loading = true;
        const result = await handleCreateOrder(this, params);
        this.loading = false;

        if (result.success) {
           const responseData = result.data;
           console.log('Reward finalized via create_order:', responseData);
           
           this.showFinalConfirmation = false;
           
           // Handle earned points if any (loyalty recursive points)
           if (responseData.points && typeof responseData.points === 'number') {
              this.earnedPoints = responseData.points;
              this.showPointsPopup = true;
              
              const currentPoints = parseInt(localStorage.getItem('user_points') || 0);
              localStorage.setItem('user_points', currentPoints + this.earnedPoints);
              this.userPoints = currentPoints + this.earnedPoints;

              setTimeout(() => {
                  this.showPointsPopup = false;
                  router.push({ name: "MisPedidos" });
                  this.showRewardPreviewModal = false;
              }, 5000);
           } else {
              // Redirect to MisPedidos like in Carrito.vue
              router.push({ name: "MisPedidos" });
              setTimeout(() => {
                this.showRewardPreviewModal = false;
              }, 500);
           }
           this.ReviseSession();
        }
      },
      handleRedemptionClick() {
        if (this.requiresPayment) {
           this.pay_bill = true;
        } else {
           this.finalizeRedemption();
        }
      },
      onPayError(error) {
        processOrderError(this, error);
      },
      onOrderError(error) {
        processOrderError(this, error);
      },
      PedidoPagado() {
        this.pay_bill = false;
        this.showFinalConfirmation = false;
        this.showRewardPreviewModal = false;
        this.ReviseSession();
        router.push({ name: "MisPedidos" });
      },
      handlePointsEarned(points) {
        this.earnedPoints = points;
        this.showPointsPopup = true;
        
        const currentPoints = parseInt(localStorage.getItem('user_points') || 0);
        localStorage.setItem('user_points', currentPoints + this.earnedPoints);
        this.userPoints = currentPoints + this.earnedPoints;

        setTimeout(() => {
            this.showPointsPopup = false;
        }, 5000);
      },
      onOrderDataSuccess(responseData) {
        const wasCounterKiosk = this.is_counter_popup || this.is_kiosk_popup;
        this.closeOrderDataPopUp();
        
        if (wasCounterKiosk) {
          // Barra and Kiosk don't call create_order internally, so we retry it here
          this.finalizeRedemption();
        } else {
           // Delivery and Takeaway endpoints already called create_order in backend
           console.log('Reward finalized via update endpoint:', responseData);
           this.showFinalConfirmation = false;
           
           if (responseData && responseData.points && typeof responseData.points === 'number') {
              this.earnedPoints = responseData.points;
              this.showPointsPopup = true;
              
              const currentPoints = parseInt(localStorage.getItem('user_points') || 0);
              localStorage.setItem('user_points', currentPoints + this.earnedPoints);
              this.userPoints = currentPoints + this.earnedPoints;

              setTimeout(() => {
                  this.showPointsPopup = false;
                  router.push({ name: "MisPedidos" });
                  this.showRewardPreviewModal = false;
              }, 5000);
           } else {
              router.push({ name: "MisPedidos" });
              setTimeout(() => {
                this.showRewardPreviewModal = false;
              }, 500);
           }
           this.ReviseSession();
        }
      },
      closeOrderDataPopUp() {
        this.is_delivery_popup = false;
        this.is_take_away_popup = false;
        this.is_counter_popup = false;
        this.is_kiosk_popup = false;
      },
    },
    mounted() {
      window.addEventListener('ewu-operational-access-blocked', this.handleOperationalAccessBlocked);
      window.addEventListener('ewu-operational-access-restored', this.handleOperationalAccessRestored);
      this.handleCartCountChanged = (event) => {
        const count = Number(event.detail);
        if (Number.isFinite(count) && count >= 0) this.carrito = count;
      };
      window.addEventListener('ewu-cart-count-changed', this.handleCartCountChanged);
      if (window.innerWidth <= 768) {
        this.isSidebarVisible = false;
      }

      if (this.$route.query.is_waiter_iframe === 'true') {
        this.$store.commit('setWaiterMode', true);
      }
      
      this.startPolling();
      this.checkLoyaltyPopup();

      if (!this.$route.meta.noTranslate) {
        loadGoogleTranslateScript()
          .then(() => {
            googleTranslateElementInit();
          })
          .catch((error) => {
            console.warn('Google Translate bootstrap is unavailable:', error);
          });
      }

      const forceTitle = () => {
        const title = document.querySelector('title');
        if (!title) return;

        const observer = new MutationObserver(() => {
          if (document.title !== 'Eat With Us') {
            document.title = 'Eat With Us';
          }
        });

        observer.observe(title, { childList: true });
      };

      forceTitle();
    },
    beforeUnmount() {
      window.removeEventListener('ewu-operational-access-blocked', this.handleOperationalAccessBlocked);
      window.removeEventListener('ewu-operational-access-restored', this.handleOperationalAccessRestored);
      if (this.handleCartCountChanged) {
        window.removeEventListener('ewu-cart-count-changed', this.handleCartCountChanged);
      }
      this.stopPolling();
    },
    watch: {
      partner_token: {
        handler(newToken) {
          this.syncPrintAgentToken(newToken);
        },
        immediate: true,
      },
      '$route.name': {
        handler(routeName) {
          if (AUTHENTICATION_ROUTE_NAMES.has(routeName)) {
            this.stopPolling();
            return;
          }
          if (!this.pollingInterval) this.startPolling();
        },
        immediate: false,
      },
      '$route.meta.authorized': {
        handler(newValue) {
          if (typeof newValue !== 'undefined') {
            this.ReviseSession();
          }
        },
        immediate: false,
      },
      loyalty_active: {
        handler(newVal) {
          if (newVal) {
            this.checkLoyaltyPopup();
          }
        }
      }
    }
  };
</script>

<style>
    .app-status-stack {
      position: relative;
      z-index: 1100;
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;
      width: 100%;
      pointer-events: none;
    }

  * {
    font-family: 'Poppins', sans-serif;;
    
  }
  body{
    background-color: #f5f5f5 !important;
  }

  /* Barra inferior del cliente (carta QR).
     En Chrome/Safari de iPhone la barra del navegador ya tapa el indicador de inicio,
     pero env(safe-area-inset-bottom) sigue devolviendo un valor > 0 y la barra quedaba
     "flotando" con un hueco blanco debajo. Solo reservamos la parte de la zona segura
     que hace falta para no pisar el indicador de inicio (PWA / pantalla completa). */
  :root {
    --customer-nav-height: 72px;
    --customer-nav-safe: max(0px, calc(env(safe-area-inset-bottom, 0px) - 20px));
    --customer-nav-total: calc(var(--customer-nav-height) + var(--customer-nav-safe));
  }

  .text-nav{
    color:var(--primary-color);
  }

  /* Keep the customer orders label readable without allowing it to wrap on
     narrow phone widths. The old ps-4 padding left too little room for the
     two-word label and made it break into two lines. */
  .footer-customer-orders {
    min-width: 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .footer-customer-orders__label {
    display: block;
    max-width: 100%;
    overflow: visible;
    white-space: nowrap;
    font-size: clamp(0.7rem, 3.4vw, 1rem);
  }

  .app-page-shell {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: rgb(243, 243, 243);
  }

  /* Pantallas de cliente (QR de mesa): fondo elegido por el restaurante en Personalización. */
  .app-page-shell--customer,
  .app-page-shell--customer .customer-section-header {
    background-color: var(--customer-bg-color, rgb(243, 243, 243));
  }

  .app-page-shell--customer > .page {
    background-color: var(--customer-bg-color, rgb(243, 243, 243)) !important;
  }

  .customer-section-header {
    position: relative;
    z-index: 11;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 12px 12px;
    background: rgb(243, 243, 243);
  }

  .customer-section-header--with-logo {
    width: min(100%, 540px);
    margin-inline: auto;
    padding: 4px 12px 6px;
  }

  .customer-section-header--with-logo .customer-section-header__brand {
    height: 82px;
  }

  .customer-section-header--with-logo .customer-section-header__brand--compact {
    height: 106px;
  }

  .customer-section-header--with-logo .customer-section-header__powered {
    top: 8px;
  }

  .customer-section-header--with-logo .customer-section-header__brand img {
    object-position: center bottom;
  }

  .customer-section-header--with-logo .customer-section-header__title {
    max-width: 100%;
    margin: 5px 0 0;
    font-size: clamp(1.25rem, 5.5vw, 1.55rem);
    line-height: 1.1;
    text-align: center;
    overflow-wrap: anywhere;
  }

  .customer-section-header__brand {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 176px;
    height: 90px;
  }

  .customer-section-header__brand--compact {
    width: 106px;
    height: 106px;
  }

  .customer-section-header__brand img {
    display: block;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    object-fit: contain;
  }

  .customer-section-header__brand--text {
    width: calc(100% - 20px);
    max-width: 300px;
    border: 0;
    background: transparent;
    box-shadow: none;
    text-align: center;
    color: #536979;
    font-size: clamp(1.25rem, 5.7vw, 1.8rem);
    font-weight: 600;
    line-height: 1.15;
    overflow-wrap: anywhere;
  }

  .customer-section-header__brand--text span {
    align-self: flex-end;
  }

  .customer-section-header__powered {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
    pointer-events: none;
  }

  .customer-section-header__powered span {
    color: var(--primary-color);
    font-size: 0.58rem;
    font-weight: 700;
    line-height: 1;
  }

  .customer-section-header__powered img {
    display: block;
    width: auto;
    height: 14px;
    max-width: 78px;
    object-fit: contain;
  }

  /* Fondo de cliente oscuro: el logo "Powered by" es negro, lo pasamos a blanco. */
  :root[data-customer-bg-tone="dark"] .customer-section-header__powered img {
    filter: invert(1);
  }

  .customer-section-header__title {
    margin: 10px 0 0;
    color: var(--customer-bg-text, #0a2533);
    font-size: clamp(1.35rem, 5.8vw, 1.7rem);
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
  }

  @media (max-width: 540px) {
    .customer-section-header__brand {
      width: min(176px, calc(100vw - 154px));
      height: 90px;
    }

    .customer-section-header__brand--compact {
      width: 106px;
      height: 106px;
    }

    .customer-section-header__brand--text {
      width: calc(100% - 20px);
      height: 78px;
    }
  }

  .app-bottom-nav{
    position: relative;
    flex: 0 0 calc(80px + env(safe-area-inset-bottom, 0px));
    width: 100%;
    height: calc(80px + env(safe-area-inset-bottom, 0px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    box-sizing: border-box;
    z-index: 10;
    background-color: transparent;
  }

  .app-bottom-nav--customer{
    flex: 0 0 var(--customer-nav-total);
    height: var(--customer-nav-total);
    padding-bottom: var(--customer-nav-safe);
  }

  .app-bottom-nav__row{
    padding-top: 12px;
  }

  /* Delivery / Take Away no usan la curva SVG: el fondo blanco debe llegar
     hasta el borde inferior, incluida la zona segura del iPhone. */
  .app-bottom-nav--solid{
    background-color: #fff;
    box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.06);
  }

  .footer-rounded{
    position: absolute;
    z-index: 0;
    bottom: 0;
    width: 100%;
    height: var(--customer-nav-total);
    pointer-events: none;
  }

  .page{
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    background-color: rgb(243, 243, 243) !important;
  }

  .page--fullpage {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100vh !important;
    height: 100dvh !important;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .phone-icon{
    position: absolute;
    bottom: calc(var(--customer-nav-total) - 10px);
    left: 44%;
    z-index: 1000;
    height: 50px;
    width: 12%;
    border-radius: 100px;
    background-color: white;
  }

  .powered{
    position: absolute;
    z-index: 10;
    bottom: calc(var(--customer-nav-total) + 10px);
    right: 3vw;
    font-size: 0.7rem;
    pointer-events: none;
  }

  .powered span{
    color:var(--primary-color);
    font-weight: bold;
  }

  .powered__logo {
    display: block;
    height: 14px;
    width: auto;
  }

  .powered--home {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
  }

  .powered--home span {
    margin-right: 0 !important;
    font-size: 0.58rem;
    line-height: 1;
  }

  .powered--home .powered__logo {
    max-width: 78px;
    object-fit: contain;
  }

  .amount-carrito{
    position:fixed;
    margin-left:12vw;
    margin-top: -11px;
    color: white;
    background-color: var(--primary-color);
    border-radius: 100px;
  }

  nav,
    .offcanvas {
      background-color: #1e293b;
    }
    .navbar-toggler {
      border: none;
    }
    .navbar-toggler:focus {
      outline: none;
      box-shadow: none;
    }

    .selected{
      color: var(--primary-color) !important;
      background-color: white;
    }

    .pagePartner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: auto;
      height: 100vh !important;
      height: 100dvh !important;
      padding: 0;
      margin-left: 0 !important;
      width: 100% !important;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      background-color: #f7f9fc;
      z-index: 1000;
    }


    /* ── TPV Floating Dock ── */
    .tpv-floating-dock {
      position: fixed;
      bottom: 24px;
      left: 24px;
      z-index: 1055;
      display: flex;
      align-items: flex-end;
      gap: 0;
    }

    .tpv-floating-dock__toggle {
      width: 52px;
      height: 52px;
      border: none;
      border-radius: 16px;
      background: #F47700;
      color: #fff;
      font-size: 1.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 4px 16px rgba(244,119,0,0.35);
      transition: all 0.25s ease;
      flex-shrink: 0;
      z-index: 2;
    }

    .tpv-floating-dock__toggle:hover {
      transform: scale(1.06);
      box-shadow: 0 6px 22px rgba(244,119,0,0.45);
    }

    .tpv-floating-dock--open .tpv-floating-dock__toggle {
      border-radius: 16px 0 0 16px;
    }

    .tpv-floating-dock__items {
      display: flex;
      align-items: stretch;
      background: #fff;
      border-radius: 0 16px 16px 0;
      box-shadow: 0 4px 24px rgba(0,0,0,0.12);
      overflow-x: auto;
      overflow-y: hidden;
      max-width: calc(100vw - 100px);
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .tpv-floating-dock__items::-webkit-scrollbar {
      display: none;
    }

    .tpv-fdock-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      padding: 10px 14px;
      text-decoration: none;
      color: #666;
      font-size: 0.68rem;
      transition: all 0.2s ease;
      flex-shrink: 0;
      gap: 4px;
      border-right: 1px solid #f0f0f0;
    }

    .tpv-fdock-item:last-child {
      border-right: none;
    }

    .tpv-fdock-item:hover {
      color: #F47700;
      background: #FFF7EE;
    }

    .tpv-fdock-item--active {
      color: #F47700;
      background: #FFF3E6;
      font-weight: 600;
    }

    .tpv-fdock-item__icon {
      font-size: 1.15rem;
    }

    .tpv-fdock-item__label {
      white-space: nowrap;
      line-height: 1.1;
    }

    .tpv-dock-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.15);
      z-index: 1054;
    }

    /* Dock slide animation */
    .dock-slide-enter-active {
      transition: all 0.3s ease;
    }
    .dock-slide-leave-active {
      transition: all 0.2s ease;
    }
    .dock-slide-enter-from,
    .dock-slide-leave-to {
      opacity: 0;
      transform: translateX(-20px) scaleX(0.7);
      transform-origin: left center;
    }

    /* Translate button partner override */
    .translate-dropdown--partner {
      left: auto !important;
      right: 1.5rem !important;
      bottom: 24px !important;
      transform: none !important;
    }

    .no-link-style {
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }

    .no-scroll {
      overflow: hidden;
    }

    .header_partner {
      width: 18%;
      position: fixed;
      top: 0;
      height: 100dvh;
      z-index: 10;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }

    .header_partner .list-group {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .header_partner .list-group li {
      color: white;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      font-size: 1.2rem;
      white-space: nowrap;
    }

    .header_partner .list-group i {
      font-size: 1.4rem;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .header_partner .list-group li a {
      display: flex;
      align-items: center;
      color: inherit;
      text-decoration: none;
    }

    iframe.goog-te-banner-frame,
    .goog-te-banner-frame,
    .goog-te-balloon-frame,
    #goog-gt-tt,
    body > .skiptranslate {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      position: absolute !important;
      top: -9999px !important;
    }
    body {
      top: 0 !important;
    }

    .dropdown-item {
      transition: padding-left 0.2s, background-color 0.2s;
    }
    .dropdown-item:hover {
      padding-left: 1.5rem;
      background-color: #f8f9fa;
    }
    .translate-dropdown {
      right: 1rem;
      bottom: 90px !important;
      width: 40px !important;
    }
    .translate-btn {
      background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color), 100%);
      color: #fff;
      font-size: 1.25rem;
      box-shadow: 0 6px 14px rgba(0,0,0,0.15);
    }
    .translate-btn:hover {
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 8px 18px rgba(0,0,0,0.2);
      transition: 0.25s;
    }
    .translate-btn:active {
      transform: translateY(4px) scale(0.98);
      box-shadow: 0 3px 8px rgba(0,0,0,0.1);
    }

    .restaurant-logo {
      position: absolute;
      z-index: 10;
      bottom: calc(var(--customer-nav-total) + 10px);
      left: 3vw;
      display: flex;
      align-items: center;
      max-width: 320px;
      height: 65px;
      overflow: hidden;
      pointer-events: none;
    }

    .logoPartner {
      height: 200px;
      width: 200px;
      object-fit: contain;
      display: block;
    }

    .restaurant-logo img {
      display: block;
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    @media (min-width: 1200px) {
      .phone-icon{
        left: 47%;
        height: 50px;
        width: 6%;
      }
    }

    @media (max-width: 1200px) {
      .pagePartner{
        margin-left: 0 !important;
        width: 100% !important;
        top: 0 !important;
        padding-top: 0 !important;
      }
    }

    @media (min-width: 767px) {
      .phone-icon{
        left: 46%;
        height: 50px;
        width: 8%;
      }
      .translate-dropdown {
        left: 1.5rem;
        bottom: 0px !important;
        transform: translateY(-50%);
      }
      .translate-btn {
        font-size: 1.75rem;
      }
      
    }

    @media (max-width: 1170px) {
      #left-menu {
        width: 25%;
        transition: 3s !important;
      }
    }

    @media (max-width: 768px) {
      #left-menu {
        width: 50%;
        transition: 3s !important;
      }

      .powered{
        top: 10px;
        right: 10px;
      }

      .restaurant-logo {
        top: 10px;
        left: 10px;
        bottom: auto;
        width: calc(100% - 136px);
        height: 64px;
      }

      .header_partner{
        width: 50%;
        padding: 5px;
      }

      .pagePartner{
        margin-left: 0 !important;
        width: 100% !important;
        top: 0 !important;
        padding-top: 0 !important;
      }

      .header_partner .list-group li{
        font-size: 1rem;
      }

      .header_partner .list-group i {
        font-size: 1.2rem;
      }

      .logoPartner {
        margin-top: 3vh;
        max-width: 80%;
      }
    }

    @media (max-width: 576px) {
      .header_partner{
        width: 25%
      }
      .header_partner .list-group li {
        font-size: 0.9rem;
      }

      .header_partner .list-group i {
        font-size: 1rem;
      }

      .logoPartner {
        max-width: 90%;
      }
    }

    @media (max-width: 400px) {
      .header_partner{
        width: 30%
      }
    }

    @media (max-height: 820px) {
      .logoPartner {
        height: 140px;
        width: 140px;
      }

      .header_partner .list-group li {
        padding: 8px 16px;
        font-size: 1.05rem;
      }
    }

    @media (max-height: 720px) {
      .logoPartner {
        height: 110px;
        width: 110px;
      }

      .header_partner .list-group li {
        padding: 6px 14px;
        font-size: 0.95rem;
      }

      .header_partner .list-group i {
        font-size: 1.1rem;
      }
    }

    @media (max-height: 640px) {
      .header_partner {
        overflow-y: auto;
      }
      
      .logoPartner {
        height: 80px;
        width: 80px;
        margin-top: 1vh;
      }

      .header_partner .list-group li {
        padding: 4px 12px;
        font-size: 0.85rem;
      }

      .header_partner .list-group i {
        font-size: 1rem;
      }

      .header_partner p {
        margin: 4px 0;
      }
    }
    /* Force ElMessage to be on top of everything including the drawer (z-index 9999) */
    .el-message {
      z-index: 20000 !important;
    }

    /* Loyalty Styles */
    .wallet-issuance {
      padding: 12px 0;
      text-align: center;
    }
    .wallet-add-button {
      border: 0;
      border-radius: 9px;
      background: #111;
      color: #fff !important;
      -webkit-text-fill-color: #fff;
      padding: 10px 18px;
      font-weight: 600;
      min-height: 44px;
    }
    .wallet-code-form label {
      display: block;
      font-size: 0.85rem;
      margin-bottom: 8px;
    }
    .wallet-code-row {
      display: flex;
      gap: 8px;
    }
    .wallet-code-row input {
      min-width: 0;
      flex: 1;
      border: 1px solid #c4c4c4;
      border-radius: 8px;
      padding: 8px 10px;
    }
    .wallet-code-row button {
      border: 0;
      border-radius: 8px;
      background: var(--primary-color);
      color: #fff;
      padding: 8px 12px;
    }
    .wallet-resend {
      border: 0;
      background: transparent;
      color: var(--primary-color);
      text-decoration: underline;
      margin-top: 8px;
      padding: 4px;
      font-size: 0.85rem;
    }
    .wallet-error {
      color: #a42b2b;
      font-size: 0.82rem;
      margin: 8px 0 0;
    }

    .user-data-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(4px);
      z-index: 10000;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
    }

    .user-data-modal {
      max-height: calc(100vh - 40px);
      max-height: calc(100dvh - 40px);
      overflow-y: auto;
      background: white;
      width: 100%;
      max-width: 400px;
      border-radius: 24px;
      padding: 24px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      position: relative;
    }

    .fade-in-up {
      animation: fadeInUp 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .modal-header-simple {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0px;
    }

    .btn-close-simple {
      background: none;
      border: none;
      font-size: 1.2rem;
      color: #aaa;
      cursor: pointer;
      padding: 5px;
      transition: color 0.2s;
    }

    .btn-close-simple:hover {
      color: #333;
    }

    .icon-circle {
      width: 70px;
      height: 70px;
      background-color: #f0f7ff;
      border-radius: 50%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }

    .form-control:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 0.25rem rgba(var(--primary-rgb), 0.15);
    }

    .floating-points {
      position: fixed;
      right: 16px;
      bottom: calc(var(--customer-nav-total) + 62px);
      z-index: 1000;
    }

    .points-badge {
      min-height: 46px;
      padding: 8px 15px;
      border: 1px solid rgba(var(--primary-color-rgb, 244, 119, 0), 0.22);
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      gap: 9px;
      background: #fff;
      box-shadow: 0 8px 24px rgba(20, 33, 47, 0.16);
      color: #152638;
      font: inherit;
      font-size: 0.87rem;
      font-weight: 800;
      cursor: pointer;
      transition: transform 0.18s ease, box-shadow 0.18s ease;
    }

    .points-badge i {
      color: var(--primary-color);
      font-size: 1rem;
    }

    .points-badge:hover,
    .points-badge:focus-visible {
      transform: translateY(-2px);
      box-shadow: 0 11px 28px rgba(20, 33, 47, 0.2);
    }

    .invite-badge {
      width: 46px;
      justify-content: center;
      padding: 0;
    }

    @media (max-width: 768px) {
      .floating-points {
        bottom: calc(var(--customer-nav-total) + 18px);
      }
    }

    .slide-in-bottom {
      animation: slideInBottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    @keyframes slideInBottom {
      0% {
        transform: translateY(100px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }

    .drawer-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(4px);
      z-index: 10001;
      display: flex;
      align-items: flex-end;
    }

    .rewards-drawer {
      background: white;
      width: 100%;
      max-height: 90vh;
      border-radius: 20px 20px 0 0;
      box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
      animation: slideUpDrawer 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      display: flex;
      flex-direction: column;
    }

    @keyframes slideUpDrawer {
      from { transform: translateY(100%); }
      to { transform: translateY(0); }
    }

    .drawer-header {
      padding: 20px;
      border-bottom: 1px solid #eee;
      position: relative;
    }

    .btn-close-drawer {
      position: absolute;
      top: 20px;
      right: 20px;
      background: none;
      border: none;
      font-size: 1.5rem;
      color: #aaa;
      cursor: pointer;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn-close-drawer:hover {
      color: #333;
    }

    .drawer-body {
      padding: 20px;
      overflow-y: auto;
      flex: 1;
    }

    .drawer-footer {
      padding: 14px 20px;
      border-top: 1px solid #eee;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .btn-logout-loyalty {
      background: none;
      border: 1.5px solid #e0e0e0;
      border-radius: 50px;
      padding: 8px 20px;
      font-size: 0.85rem;
      font-weight: 600;
      color: #888;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: all 0.2s ease;
      width: 100%;
      justify-content: center;
    }

    .btn-logout-loyalty:hover {
      background-color: #fff0f0;
      border-color: #e74c3c;
      color: #e74c3c;
    }

    .rewards-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .reward-card {
      background: white;
      border: 1.5px solid #ebebeb;
      border-radius: 16px;
      padding: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      gap: 12px;
      margin-bottom: 4px;
    }

    .reward-card:not(.disabled) {
      border-color: var(--primary-color);
      background: white;
      box-shadow: 0 4px 12px rgba(var(--primary-rgb), 0.08);
    }

    .reward-card.disabled {
      opacity: 0.8;
      background: #fafafa;
      border-color: #eee;
    }

    .reward-content {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      min-width: 0;
    }

    .reward-badge {
      background: #e0e0e0;
      color: #777;
      padding: 6px 12px;
      border-radius: 12px;
      font-weight: 700;
      font-size: 0.8rem;
      white-space: nowrap;
      min-width: 75px;
      text-align: center;
      display: flex;
      flex-direction: column;
      line-height: 1.1;
      justify-content: center;
      flex-shrink: 0;
    }

    .reward-badge .points-number {
      font-size: 1rem;
      font-weight: 800;
    }

    .reward-badge .points-label {
      font-size: 0.55rem;
      font-weight: 600;
      letter-spacing: 0.5px;
      margin-top: -2px;
      opacity: 0.9;
    }

    .reward-card:not(.disabled) .reward-badge {
      background-color: var(--primary-color);
      color: white;
    }

    .reward-info {
      display: flex;
      flex-direction: column;
      min-width: 0;
      flex: 1;
    }

    .reward-title {
      font-weight: 600;
      color: #333;
      font-size: 0.9rem;
      line-height: 1.3;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    /* Redeened Reward Ticket Styles */
    .redeemed-reward-ticket {
      background: #fdfdfd;
      border: 1px solid #eee;
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      position: relative;
    }

    .ticket-dashed-line {
      border-top: 2px dashed #eee;
      margin: 0 10px;
    }

    .ticket-content {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    .ticket-footer {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    .plate-details img {
       box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    /* Reward Selection Styles */
    .plate-selection-list {
      max-height: 250px;
      overflow-y: auto;
      padding-right: 5px;
    }

    .plate-selection-item {
      cursor: pointer;
      transition: all 0.2s;
      border: 1.5px solid #eee !important;
    }

    .plate-selection-item:hover {
      border-color: var(--primary-color) !important;
      background-color: rgba(var(--primary-rgb), 0.02) !important;
    }

    .plate-selection-item.selected {
      border-color: var(--primary-color) !important;
      background-color: rgba(var(--primary-rgb), 0.05) !important;
    }

    .discount-banner {
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: pulseBanner 2s infinite;
    }

    .cart-preview-list::-webkit-scrollbar {
      width: 4px;
    }

    .cart-preview-list::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 10px;
    }

    .last-child-mb-0:last-child {
      margin-bottom: 0 !important;
    }

    @keyframes pulseBanner {
      0% { box-shadow: 0 0 0 0 rgba(251, 192, 45, 0.4); }
      70% { box-shadow: 0 0 0 10px rgba(251, 192, 45, 0); }
      100% { box-shadow: 0 0 0 0 rgba(251, 192, 45, 0); }
    }
    .rewards-drawer {
      width: min(100%, 560px);
      max-height: min(90vh, 820px);
      max-height: min(90dvh, 820px);
      margin: 0 auto;
      overflow: hidden;
      border-radius: 26px 26px 0 0;
      background: #f6f7fa;
    }

    .drawer-header {
      min-height: 112px;
      padding: 20px 68px 18px 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 14px;
      background-color: #fffaf5;
      background-image: radial-gradient(ellipse at 92% 0, rgba(var(--primary-rgb), 0.14), transparent 40%), linear-gradient(135deg, #ffffff 0%, #fffaf5 100%);
      border-bottom: 1px solid rgba(20, 30, 50, 0.07);
    }

    .drawer-heading {
      min-width: 0;
    }

    .drawer-kicker {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 5px;
      color: var(--primary-color);
      font-size: 0.65rem;
      font-weight: 800;
      letter-spacing: 0.12em;
    }

    .drawer-heading h5 {
      margin: 0 0 3px;
      color: #20283a;
      font-size: 1.3rem;
      font-weight: 800;
      letter-spacing: -0.035em;
    }

    .drawer-heading p {
      margin: 0;
      color: #737d8e;
      font-size: 0.82rem;
    }

    .drawer-balance {
      display: flex;
      flex: 0 0 auto;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 76px;
      padding: 9px 12px;
      border: 1px solid rgba(var(--primary-rgb), 0.16);
      border-radius: 16px;
      background: #fff;
      box-shadow: 0 5px 14px rgba(31, 41, 55, 0.06);
    }

    .drawer-balance > span {
      color: #7a8494;
      font-size: 0.62rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.08em;
    }

    .drawer-balance strong {
      color: var(--primary-color);
      font-size: 1.12rem;
      font-weight: 850;
      line-height: 1.2;
      white-space: nowrap;
    }

    .drawer-balance small {
      font-size: 0.68rem;
      font-weight: 700;
    }

    .drawer-body {
      padding: 16px 18px 22px;
      background: #f6f7fa;
    }

    .rewards-list {
      gap: 14px;
    }

    .reward-card {
      display: block;
      position: relative;
      overflow: hidden;
      margin: 0;
      padding: 16px;
      border: 1px solid #e5e9f0;
      border-radius: 20px;
      background: #fff;
      box-shadow: 0 7px 22px rgba(25, 36, 55, 0.055);
      transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    }

    .reward-card:not(.disabled) {
      border-color: var(--primary-color);
      background: linear-gradient(145deg, #ffffff 0%, #fffaf5 100%);
      box-shadow: 0 9px 24px rgba(var(--primary-rgb), 0.13);
    }

    .reward-card.disabled {
      opacity: 1;
      border-color: #e5e9f0;
      background: #fff;
    }

    .reward-card__top,
    .reward-kind {
      display: flex;
      align-items: center;
    }

    .reward-card__top {
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 12px;
    }

    .reward-kind {
      min-width: 0;
      gap: 9px;
      color: #657084;
      font-size: 0.72rem;
      font-weight: 750;
      letter-spacing: 0.015em;
    }

    .reward-kind__icon {
      display: inline-flex;
      flex: 0 0 36px;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 12px;
      background: #eef1f5;
      color: #697588;
      font-size: 0.95rem;
    }

    .reward-kind__icon.is-ready {
      background: rgba(var(--primary-rgb), 0.12);
      color: var(--primary-color);
    }

    .reward-cost {
      flex: 0 0 auto;
      padding: 6px 10px;
      border: 1px solid rgba(var(--primary-rgb), 0.16);
      border-radius: 999px;
      background: rgba(var(--primary-rgb), 0.07);
      color: var(--primary-color);
      font-size: 0.72rem;
      font-weight: 800;
      white-space: nowrap;
    }

    .reward-cost--purchase {
      border-color: #e7eaf0;
      background: #f4f5f7;
      color: #677184;
    }

    .reward-title {
      display: block;
      margin: 0 0 5px;
      overflow: visible;
      color: #20283a;
      font-size: 1.03rem;
      font-weight: 800;
      line-height: 1.3;
      letter-spacing: -0.02em;
    }

    .reward-description {
      margin: 0;
      color: #6d7788;
      font-size: 0.82rem;
      line-height: 1.45;
    }

    .reward-description__gift {
      display: block;
      color: #485366;
      font-weight: 700;
    }

    .reward-progress {
      margin-top: 15px;
      padding: 12px 13px 10px;
      border: 1px solid #edf0f4;
      border-radius: 15px;
      background: rgba(246, 247, 250, 0.85);
    }

    .reward-progress__meta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      color: #6e7888;
      font-size: 0.7rem;
    }

    .reward-progress__meta > span {
      font-weight: 750;
      letter-spacing: 0.045em;
      text-transform: uppercase;
    }

    .reward-progress__meta strong {
      color: #263044;
      font-size: 0.8rem;
      font-weight: 850;
      text-align: right;
    }

    .reward-progress__track {
      height: 9px;
      margin-top: 9px;
      overflow: hidden;
      border-radius: 999px;
      background: #e5e9ef;
    }

    .reward-progress__fill {
      height: 100%;
      min-width: 0;
      border-radius: inherit;
      background: linear-gradient(90deg, var(--primary-color), #ffb14a);
      box-shadow: 0 1px 5px rgba(var(--primary-rgb), 0.25);
      transition: width 0.45s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .reward-progress__status {
      display: flex;
      align-items: center;
      gap: 6px;
      min-height: 19px;
      margin-top: 8px;
      color: #727d8e;
      font-size: 0.75rem;
      font-weight: 650;
    }

    .reward-progress__status.is-ready {
      color: #13865b;
    }

    .reward-card__footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-top: 13px;
    }

    .reward-unlocked,
    .reward-locked-note {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      min-width: 0;
      color: #6d7788;
      font-size: 0.72rem;
      font-weight: 700;
    }

    .reward-unlocked {
      color: #13865b;
    }

    .reward-action {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      gap: 9px;
      min-height: 42px;
      padding: 0 16px;
      border: 0;
      border-radius: 13px;
      background: var(--primary-color);
      box-shadow: 0 5px 13px rgba(var(--primary-rgb), 0.24);
      color: #fff;
      font-size: 0.8rem;
      font-weight: 800;
      transition: transform 0.18s ease, box-shadow 0.18s ease;
    }

    .reward-action:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 17px rgba(var(--primary-rgb), 0.3);
    }

    @media (max-width: 380px) {
      .drawer-header {
        gap: 8px;
        padding-left: 16px;
      }

      .drawer-balance {
        min-width: 66px;
        padding: 8px 9px;
      }

      .drawer-heading h5 {
        font-size: 1.15rem;
      }

      .drawer-heading p {
        max-width: 180px;
        font-size: 0.75rem;
      }

      .drawer-body {
        padding-right: 12px;
        padding-left: 12px;
      }

      .reward-card {
        padding: 14px;
      }

      .reward-progress__meta strong {
        font-size: 0.74rem;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .reward-card,
      .reward-progress__fill,
      .reward-action {
        transition: none;
      }
    }

</style>
